import { LegacyRef, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { GetModelsSuccessResponse, ModelWithLoaded } from "../../../../../../../types/api/model/get-models-success-response";
import { useDispatch } from "react-redux";
import { AxiosResponse } from "axios";
import { useNavigate } from "react-router-dom";
import './company-admin-model-index.css';
import { CreateModelSuccessResponse } from "../../../../../../../types/api/model/create-model-success-response";
import * as THREE from 'three';
import { GetProcessStepsSuccessResponse, NewProcessStepWithEndpointModelGeneratedAndDoneAndStartingModelName, ProcessStepWithEndpointModelGeneratedAndDoneAndStartingModelName } from "../../../../../../../types/api/process-step/get-process-steps-success-response";
import { Tool } from "../../../../../../../types/api/tool/get-tools-success-response";
import { ModelInModelTreeInProcessEditor } from "../../../../../../../utils/create-model-tree-for-porcess-editor-and-set-uuid/create-model-tree-for-porcess-editor-and-set-uuid";
import { getModelFromModelTreeInPorcessEditorByUUID } from "../../../../../../../utils/get-model-from-model-tree-in-process-editor-by-uuid/get-model-from-model-tree-in-process-editor-by-uuid";
import { CreateProcessStepSuccessResponse } from "../../../../../../../types/api/process-step/create-process-step-success-response";
import { CreateProcessStepItemSuccessResponse } from "../../../../../../../types/api/process-step-item/create-process-step-item-success-response";
import { useImmer } from 'use-immer';
import { getModelFromModelTreeInModelSpaceByUUID } from "../../../../../../../utils/get-model-from-model-tree-in-model-space-by-uuid/get-model-from-model-tree-in-model-space-by-uuid";
import { deleteModelFromModelTreeInModelSpaceByUUID } from "../../../../../../../utils/delete-model-from-model-tree-in-model-space/delete-model-from-model-tree-in-model-space";
import { GetLayersSuccessResponse } from "../../../../../../../types/api/layer/get-layers-success-response";
import { NewLayerItemWithChangeableSubmodelName } from "../../../../../../../types/api/layer-item/layer-item";
import { LayerWithNewLayerItemTooAndChangeableSubmodelName, NewLayerithChangeableSubmodelName } from "../../../../../../../types/api/layer/layer";
import { CreateLayerSuccessResponse } from "../../../../../../../types/api/layer/create-layer-success-response";
import { CreateLayerItemSuccessResponse } from "../../../../../../../types/api/layer-item/create-layer-item-success-response";
import { ModelInModelTreeInLayerEditor } from "../../../../../../../utils/create-model-tree-for-layer-editor-and-set-uuid/create-model-tree-for-layer-editor-and-set-uuid";
import { NewProcessStepItemWithEndpointModelAndDoneAndStartingModelNameAndReferenceModelName, ProcessStepItemWithEndpointModelAndDoneAndStartingModelNameAndReferenceModelName } from "../../../../../../../types/api/process-step-item/process-step-item";
import { findNodeAndParentInModelTreeInProcessEditor } from "../../../../../../../utils/find-node-and-parent-in-model-tree-in-process-editor/find-node-and-parent-in-model-tree-in-process-editor";
import { isAncestorInModelTreeInProcessEditor } from "../../../../../../../utils/is-ancestor-in-model-tree-in-process-editor/is-ancestor-in-model-tree-in-process-editor";
import _ from 'lodash';
import { Project } from "../../../../../../../types/api/project/get-project-success-response";
import { networkCall } from "../../../../../../../../../utils/network-call/network-call";
import { showLoadingAlertMessage } from "../../../../../../../../../utils/show-loading-alert-message/show-loading-alert-message";
import { clearAlertMessage, showAlertMessage } from "../../../../../../../../../redux/reducer/alert-message.reducer";
import { AlertMessages } from "../../../../../../../../../enums/alert-messages.enum";
import { EditorDataViewer } from "../../../../../../../components/editor-data-viewer/editor-data-viewer";
import { GetWorkInstructionsSuccessResponse } from "../../../../../../../types/api/work-instruction/get-work-instructions-success-response";
import { ProcessEditor, ProcessEditorActionStatus, ProcessEditorRef } from "../../../../../../../components/process-editor/process-editor";
import { ViewportShading as ViewportShadingInModelSpace } from "../../../../../../../components/model-space/viewport-shading-select/viewport-shading-select";
import { ViewportShading as ViewportShadingInProcessEditor } from "../../../../../../../components/process-editor/viewport-shading-select/viewport-shading-select";
import { ViewportShading as ViewportShadingInLayerEditor } from "../../../../../../../components/layer-editor/viewport-shading-select/viewport-shading-select";
import { ModelTree as ModelTreeInProcessEditor } from "../../../../../../../components/process-editor/model-tree/model-tree";
import { LayerEditor, LayerEditorActionStatus, LayerEditorRef } from "../../../../../../../components/layer-editor/layer-editor";
import { ModelInModelTree as ModelInModelTreeInModelSpace, ModelSpace, ModelSpaceRef, WorkInstructionWithUUIDs } from "../../../../../../../components/model-space/model-space";
import { ModelTree as ModelTreeInLayerEditor } from "../../../../../../../components/layer-editor/model-tree/model-tree";

export type ModelEditorType = 'modelSpace' | 'processEditor' | 'layerEditor';

type CompanyAdminModelIndexProps = {
    project: Project;
};

export const CompanyAdminModelIndex = ({ project }: CompanyAdminModelIndexProps) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activeModelEditorType, setActiveModelEditorType] = useState<ModelEditorType>('modelSpace');
    const [prevActiveModelEditorType, setPrevActiveModelEditorType] = useState<typeof activeModelEditorType>();
    const [isPOIActive, setIsPOIActive] = useState(false);

    const [workInstructions, setWorkInstructions] = useState<WorkInstructionWithUUIDs[]>([]);
    const [areWorkInstructionsInModelSpaceChanged, setAreWorkInstructionsInModelSpaceChanged] = useState(false);
    // model space-hez tartozó adatok
    const [modelTreeInModelSpace, updateModelTreeInModelSpace] = useImmer<ModelInModelTreeInModelSpace[]>([]);
    const [selectedModelUUIDInModelSpace, setSelectedModelUUIDInModelSpace] = useState<string | null>(null);
    const [areModelsInModelSpaceChanged, setAreModelsInModelSpaceChanged] = useState(false);
    const newModelIdRef = useRef(-1);
    const modelSpaceRef = useRef<ModelSpaceRef>();
    const areModelSpaceModelsLoading = useMemo(() => {
         if (modelTreeInModelSpace.length > 0) {
            for (const model of modelTreeInModelSpace) {
                if (model.loaded === false) return true;
            }
        }

        return false;
    }, [modelTreeInModelSpace]);
    const modelsUUIDsToDeleteInModelSpaceRef = useRef<Set<string>>(new Set());
    const resetModelSpaceData = useCallback(() => {
        updateModelTreeInModelSpace([]);
        setSelectedModelUUIDInModelSpace(null);
        setAreModelsInModelSpaceChanged(false);
        newModelIdRef.current = -1;
        modelsUUIDsToDeleteInModelSpaceRef.current = new Set();
    }, [updateModelTreeInModelSpace]);
    const [viewportShadingInModelSpace, setViewportShadingInModelSpace] = useState<ViewportShadingInModelSpace>('solid');
    const [prevViewportShadingInModelSpace, setPrevViewportShadingInModelSpace] = useState<typeof viewportShadingInModelSpace>(viewportShadingInModelSpace);
    // process editor-hoz tartozó adatok
    const [processEditorActionStatus, setProcessEditorActionStatus] = useState<ProcessEditorActionStatus>();
    const [prevProcessEditorActionStatus, setPrevProcessEditorActionStatus] = useState<typeof processEditorActionStatus>();
    const [modelsInProcessEditor, setModelsInProcessEditor] = useState<ModelWithLoaded[]>([]);
    const [modelTreeInProcessEditor, setModelTreeInProcessEditor] = useState<ModelInModelTreeInProcessEditor[]>([]);
    const originalModelTreeInProcessEditorRef = useRef<typeof modelTreeInProcessEditor>([]);
    const [processSteps, setProcessSteps] = useState<(ProcessStepWithEndpointModelGeneratedAndDoneAndStartingModelName | NewProcessStepWithEndpointModelGeneratedAndDoneAndStartingModelName)[]>([]);
    const [areProcessStepsInProcessEditorChanged, setAreProcessStepsInProcessEditorChanged] = useState(false);
    const [selectedModelUUIDInProcessEditor, setSelectedModelUUIDInProcessEditor] = useState<string | null>(null);
    const [selectedProcessStepItemIdInProcessEditor, setSelectedProcessStepItemIdInProcessEditor] = useState<number | null>(null);
    const [prevSelectedProcessStepItemIdInProcessEditor, setPrevSelectedProcessStepItemIdInProcessEditor] = useState<typeof selectedProcessStepItemIdInProcessEditor>();
    const selectedProcessStepItem = useMemo(() => {
        if (selectedProcessStepItemIdInProcessEditor === null) return undefined;

        for (const processStep of processSteps) {
            if (processStep.processStepItems) {
                for (const processStepItem of processStep.processStepItems) {
                    if (processStepItem.id === selectedProcessStepItemIdInProcessEditor)
                        return processStepItem;
                }
            }
        }

        return undefined;
    }, [selectedProcessStepItemIdInProcessEditor, processSteps]);
    const [selectedProcessStepId, setSelectedProcessStepId] = useState<number | null>(null);
    const [prevSelectedProcessStepId, setPrevSelectedProcessStepId] = useState<typeof selectedProcessStepId>();
    const processStepIdsToDeleteRef = useRef<number[]>([]);
    const processStepItemIdsToDeleteRef = useRef<number[]>([]);
    const instructionInProcessEditor = useMemo<string | null>(() => {
        
        if (processSteps.length === 0) {
            return 'Hozzon létre folyamat lépést a jobb oldali sávban található + gombbal!';
        }

        if (selectedProcessStepId === null) {
            return 'Hozzon létre folyamat lépést a jobb oldali sávban található + gombbal vagy nyissa le valamelyik lépést!';
        } else {
            if (selectedProcessStepItemIdInProcessEditor === null) {

                const processStep = processSteps.find(processStep => processStep.id === selectedProcessStepId);
                if (!processStep) return null;

                if (processStep.processStepItems && processStep.processStepItems.length > 0)
                    return 'Hozzon létre folyamat lépést elemet a jobb oldali sávban található "+ Elem hozzáadása" gombbal vagy nyissa le valamelyik elemet!';
                else return 'Hozzon létre folyamat lépés elemet a jobb oldali sávban található "+ Elem hozzáadása" gombbal!';
            
            } else {

                switch (processEditorActionStatus) {
                    case 'clickOnStartingPointMenuItem':
                        return 'A jobb oldali sávban kattintson az “Elem kiválasztása gombra!';
                    case 'selectingStartingModel':
                        return 'Válassza ki a modelltérben vagy az alatta lévő hierarchiában a kijelölt lépés elem mozgatandó modelljét, majd állítsa be láthatóságát! Ha kész, menjen tovább a "Referenciapont" gombra!';
                    case 'selectingReferenceModel':
                        return 'Válassza ki a referenciamodellt a modelltérben vagy az alatta lévő hierarchiában! Ha kész, kattintson az "Eszköz" gombra, ha szükséges eszköz, ha nem, kattintson az "Elem végpont" gombra!';
                    case 'selectingTool':
                        return 'Kattintson a jobb oldali sávban az "Eszköz" gombra, majd válasszok eszközt, ha szükséges. Ha nem szükséges, kattintson az "Elem végpont"-ra!';
                    case 'clickOnEndpointMenuItem':
                        return 'Kattintson a jobb oldai sávban az "Elem végpont" gombra!';
                    case 'settingEndpointModel':
                        return 'Állítsa be a (piros/)halványabb másolat pozícióját és rotációját! Ha készen van a lépéselem, kattintson a "Kész" gombra!';
                    case 'clickToDone':
                        return 'Ha készen van a lépéselem, kattintson a "Kész" gombra!';
                    case 'done':
                        return 'A lépéselem beállítása kész. Ha módosítani szeretné, kattintson valamelyik menüelemre a jobb oldali sávban.';
                    default:
                        return 'A jobb oldali sávban kattintson az “Elem kiválasztása" gombra!';
                }
            }
        }

    }, [processSteps, selectedProcessStepId, selectedProcessStepItemIdInProcessEditor, processEditorActionStatus]);
    const areProcessEditorModelsLoading = useMemo(() => {
        if (modelsInProcessEditor.length > 0) {
            for (const model of modelsInProcessEditor) {
                if (model.loaded === false) return true;
            }
        }

        return false;
    }, [modelsInProcessEditor]);
    const [prevAreProcessEditorModelsLoading, setPrevAreProcessEditorModelsLoading] = useState<typeof areProcessEditorModelsLoading>();
    const processEditorRef = useRef<ProcessEditorRef>();
    const skipModelChangeInProcessEditorRef = useRef(true);
    const resetProcessEditorData = useCallback(() => {
        setProcessEditorActionStatus(undefined);
        setPrevProcessEditorActionStatus(undefined);
        setModelsInProcessEditor([]);
        setModelTreeInProcessEditor([]);
        setProcessSteps([]);
        setAreProcessStepsInProcessEditorChanged(false);
        setSelectedModelUUIDInProcessEditor(null);
        setSelectedProcessStepItemIdInProcessEditor(null);
        setPrevSelectedProcessStepItemIdInProcessEditor(undefined);
        setSelectedProcessStepId(null);
        setPrevSelectedProcessStepId(undefined);
        processStepIdsToDeleteRef.current = [];
        processStepItemIdsToDeleteRef.current = [];
        skipModelChangeInProcessEditorRef.current = true;
    },[]);
    const [viewportShadingInProcessEditor, setViewportShadingInProcessEditor] = useState<ViewportShadingInProcessEditor>('solid');
    const [prevViewportShadingInProcessEditor, setPrevViewportShadingInProcessEditor] = useState<typeof viewportShadingInProcessEditor>(viewportShadingInProcessEditor);
    // layer editor-hoz tartozó adatok
    const [modelsInLayerEditor, setModelsInLayerEditor] = useState<ModelWithLoaded[]>([]);
    const [modelTreeInLayerEditor, setModelTreeInLayerEditor] = useState<ModelInModelTreeInLayerEditor[]>([]);
    const [selectedModelUUIDInLayerEditor, setSelectedModelUUIDInLayerEditor] = useState<string | null>(null);
    const [selectedLayerId, setSelectedLayerId] = useState<number | null>(null);
    const [prevSelectedLayerId, setPrevSelectedLayerId] = useState<typeof selectedLayerId>();
    const [selectedLayerItemId, setSelectedLayerItemId] = useState<number | null>(null);
    const [prevSelectedLayerItemId, setPrevSelectedLayerItemId] = useState<typeof selectedLayerItemId>();
    const [layers, setLayers] = useState<(LayerWithNewLayerItemTooAndChangeableSubmodelName | NewLayerithChangeableSubmodelName)[]>([]);
    const [areLayersInLayerEditorChanged, setAreLayersInLayerEditorChanged] = useState(false);
    const areLayerEditorModelsLoading = useMemo(() => {
        if (modelsInLayerEditor.length > 0) {
            for (const model of modelsInLayerEditor) {
                if (model.loaded === false) return true;
            }
        }

        return false;
    }, [modelsInLayerEditor]);
    const layerIdsToDeleteRef = useRef<Set<number>>(new Set());
    const layerItemIdsToDeleteRef = useRef<Set<number>>(new Set());
    const [layerEditorActionStatus, setLayerEditorActionStatus] = useState<LayerEditorActionStatus | null>(null);
    const [prevLayerEditorActionStatus, setPrevLayerEditorActionStatus] = useState<typeof layerEditorActionStatus>();
    const instructionInLayerEditor = useMemo<string>(() => {
        if (layers.length === 0)
            return 'Hozzon létre réteget a jobb oldali sávban található + gombbal!';

        if (selectedLayerId === null)
            return 'Hozzon létre réteget a jobb oldali sávban található + gombbal, vagy nyisson le egyet!';

        if (selectedLayerItemId === null) {
            const layer = layers.find(_layer => _layer.id === selectedLayerId);

            if (layer) {

                if (layer.layerItems && layer.layerItems.length > 0)
                    return 'Hozzon létre rétegelemet vagy nyisson le egyet a jobb oldali sávban!';

                return 'Hozzon létre rétegelemet a jobb oldali sávban található + gombbal!';

            } else return 'Hozzon létre réteget a jobb oldali sávban található + gombbal, vagy nyisson le egyet!';
        }

        switch (layerEditorActionStatus) {
            case 'nameTheLayerItemThenClickOnSelectModel':
                return 'Nevezze el a rétegelemet vagy kattintson az "Elem kiválasztás" gombra a modell kiválasztásához!';
            case 'selectingModel':
                return 'Válassza ki a modelltérből vagy az alatta lévő hierarchiából az elemet!';
            case 'settingModel':
                return 'Állítsa be a kiválasztott modell(elem) pozicióját és rotációját! Ha másik modell szeretne választani, kattintson a "Másik modell választok"-ra! Ha kész, kattintson a jobb oldali sávban a "Subelem kiválasztás" gombra!';
            case 'selectingSubmodel':
                return 'Válassza ki a modelltérből vagy az alatta lévő hierarchiából a subelem modellt!';
            case 'settingSubmodel':
                return 'Állítsa be a kiválasztott modell(subelem) pozicióját és rotációját! Ha másik modell szeretne választani, kattintson a "Másik modell választok"-ra! Ha kész, kattintson a jobb oldali sávban a "Subelem név" gombra!';
            case 'clickOnSubmodelName':
                return 'Kattintson a "Subelem név" gombra a jobb oldali sávban!';
            case 'settingSubmodelName':
                return 'Nevezze el a subelemet a jobb oldali sávban!';
            default:
                return 'Kattinstson a "Elem kiválasztás" gombra a jobb oldali sávban!';
        }
    }, [layers, selectedLayerId, selectedLayerItemId, layerEditorActionStatus]);
    const layerEditorRef = useRef<LayerEditorRef>();
    const skipModelChangeInLayerEditorRef = useRef(true);
    const resetLayerEditorData = useCallback(() => {
        setModelsInLayerEditor([]);
        setModelTreeInLayerEditor([]);
        setSelectedModelUUIDInLayerEditor(null);
        setSelectedLayerId(null);
        setPrevSelectedLayerId(undefined);
        setSelectedLayerItemId(null);
        setPrevSelectedLayerItemId(undefined);
        setLayers([]);
        setAreLayersInLayerEditorChanged(false);
        layerIdsToDeleteRef.current = new Set();
        layerItemIdsToDeleteRef.current = new Set();
        setLayerEditorActionStatus(null);
        setPrevLayerEditorActionStatus(undefined);
        skipModelChangeInLayerEditorRef.current = true;
    }, []);
    const [viewportShadingInLayerEditor, setViewportShadingInLayerEditor] = useState<ViewportShadingInLayerEditor>('solid');
    const [prevViewportShadingInLayerEditor, setPrevViewportShadingInLayerEditor] = useState<typeof viewportShadingInLayerEditor>(viewportShadingInLayerEditor);

    // adatok lekérése
    useEffect(() => {
        let ignore = false;

        if (activeModelEditorType === 'modelSpace' && project.modelSpaceModule) {
            
            resetModelSpaceData();
            
            const getData = async () => {
                showLoadingAlertMessage();

                if (project.workInstructionModule) {

                    const [getModelsResponse, getWorkinstructionsResponse] = await Promise.all([
                        networkCall(`/projects/${ project.id }/models`),
                        networkCall(`/projects/${ project.id }/work-instructions`)
                    ]);
    
                    dispatch(clearAlertMessage());

                    if (ignore) return;

                    if (getModelsResponse?.status !== 200 || getWorkinstructionsResponse?.status !== 200) {
                        dispatch(showAlertMessage({
                            alertMessageType: 'error',
                            alertMessageText: 'Hiba történt az adatok lekérdezése közben. Kérjük, próbálja újra!'
                        }));
                        return;
                    }
    
                    const getModelsRes: AxiosResponse<GetModelsSuccessResponse> = getModelsResponse;

                    const _modelTreeInModelSpace: ModelInModelTreeInModelSpace[] = [];
                    for (const model of getModelsRes.data.models) {
                        _modelTreeInModelSpace.push({
                            id: model.id,
                            uuid: model.uuid,
                            originalModel: model.originalModel,
                            modifiedModel: model.modifiedModel?.url ?? undefined,
                            name: model.name,
                            visible: model.visible,
                            isRoot: true,
                            loaded: false,
                            position: [model.xPosition, model.yPosition, model.zPosition],
                            rotation: [model.xRotation, model.xRotation, model.zRotation],
                            scale: [model.xScale, model.yScale, model.zScale],
                            children: []
                        });
                    }
                    updateModelTreeInModelSpace(_modelTreeInModelSpace);
    
                    const getWorkInstructionsRes: AxiosResponse<GetWorkInstructionsSuccessResponse> = getWorkinstructionsResponse;
                    const workInstructionsWithUUID: WorkInstructionWithUUIDs[] = [];
                    for (const workInstruction of getWorkInstructionsRes.data.workInstructions) {
                        workInstructionsWithUUID.push({
                            ...workInstruction,
                            POIUUID: THREE.MathUtils.generateUUID(),
                            POILineEndpointUUID: THREE.MathUtils.generateUUID()
                        });
                    }
                    setWorkInstructions(workInstructionsWithUUID);

                } else {

                    const getModelsResponse = await networkCall(`/projects/${ project.id }/models`);

                    dispatch(clearAlertMessage());

                    if (ignore) return;

                    if (getModelsResponse?.status !== 200) {
                        dispatch(showAlertMessage({
                            alertMessageType: 'error',
                            alertMessageText: 'Hiba történt az adatok lekérdezése közben. Kérjük, próbálja újra!'
                        }));
                        return;
                    }
    
                    const getModelsRes: AxiosResponse<GetModelsSuccessResponse> = getModelsResponse;

                    const _modelTreeInModelSpace: ModelInModelTreeInModelSpace[] = [];
                    for (const model of getModelsRes.data.models) {
                        _modelTreeInModelSpace.push({
                            id: model.id,
                            uuid: model.uuid,
                            originalModel: model.originalModel,
                            modifiedModel: model.modifiedModel?.url ?? undefined,
                            name: model.name,
                            visible: model.visible,
                            isRoot: true,
                            loaded: false,
                            position: [model.xPosition, model.yPosition, model.zPosition],
                            rotation: [model.xRotation, model.xRotation, model.zRotation],
                            scale: [model.xScale, model.yScale, model.zScale],
                            children: []
                        });
                    }
                    updateModelTreeInModelSpace(_modelTreeInModelSpace);

                }
                
            };
            getData();

            return () => {
                ignore = true;
            };

        } else if (activeModelEditorType === 'processEditor' && project.processEditorModule) {
            
            resetProcessEditorData();

            const getData = async () => {
                showLoadingAlertMessage();

                if (project.workInstructionModule) {

                    const [getModelsResponse, getProcessStepsResponse, getWorkinstructionsResponse] = await Promise.all([
                        networkCall(`/projects/${ project.id }/models`),
                        networkCall(`/projects/${ project.id }/process-steps`),
                        networkCall(`/projects/${ project.id }/work-instructions`)
                    ]);
    
                    dispatch(clearAlertMessage());

                    if (ignore) return;

                    if (getModelsResponse?.status !== 200 || getProcessStepsResponse?.status !== 200 || getWorkinstructionsResponse?.status !== 200) {
                        dispatch(showAlertMessage({
                            alertMessageType: 'error',
                            alertMessageText: 'Hiba történt az adatok lekérdezése közben. Kérjük, próbálja újra!'
                        }));
                        return;
                    }

                    const getModelsRes: AxiosResponse<GetModelsSuccessResponse> = getModelsResponse;

                    const _modelTreeInProcessEditor: ModelInModelTreeInProcessEditor[] = [];
                    const models: ModelWithLoaded[] = [];
                    for (const model of getModelsRes.data.models) {

                        _modelTreeInProcessEditor.push({
                            uuid: model.uuid,
                            name: model.name,
                            visible: model.visible,
                            position: [model.xPosition, model.yPosition, model.zPosition],
                            rotation: [model.xRotation, model.yRotation, model.zRotation],
                            scale: [model.xScale, model.yScale, model.zScale],
                            isPartOfAModel: false,
                            children: []
                        });

                        models.push({
                            ...model,
                            loaded: false
                        });
                    }
                    setModelTreeInProcessEditor(_modelTreeInProcessEditor);
                    setModelsInProcessEditor(models);
    
                    const getProcessStepsRes: AxiosResponse<GetProcessStepsSuccessResponse> = getProcessStepsResponse;

                    const processStepsWithEndpointModel: typeof processSteps = [];
                    for (const processStep of getProcessStepsRes.data.processSteps) {
                        processStepsWithEndpointModel.push({
                            ...processStep,
                            processStepItems: processStep.processStepItems?.map(processStepItem => ({
                                ...processStepItem,
                                endpointModelUUID: (processStepItem.modelToBeMovedUUID && processStepItem.isModelToBeMovedVisible && processStepItem.hasTargetModel) ? THREE.MathUtils.generateUUID() : null,
                                done: processStepItem.modelToBeMovedUUID ? true : false
                            }))
                        });
                    }

                    setProcessSteps(processStepsWithEndpointModel);
    
                    const getWorkInstructionsRes: AxiosResponse<GetWorkInstructionsSuccessResponse> = getWorkinstructionsResponse;
                    const workInstructionsWithUUID: WorkInstructionWithUUIDs[] = [];
                    for (const workInstruction of getWorkInstructionsRes.data.workInstructions) {
                        workInstructionsWithUUID.push({
                            ...workInstruction,
                            POIUUID: THREE.MathUtils.generateUUID(),
                            POILineEndpointUUID: THREE.MathUtils.generateUUID()
                        });
                    }
                    setWorkInstructions(workInstructionsWithUUID);

                } else {

                    const [getModelsResponse, getProcessStepsResponse] = await Promise.all([
                        networkCall(`/projects/${ project.id }/models`),
                        networkCall(`/projects/${ project.id }/process-steps`)
                    ]);
                    
                    dispatch(clearAlertMessage());

                    if (ignore) return;

                    if (getModelsResponse?.status !== 200 || getProcessStepsResponse?.status !== 200) {
                        dispatch(showAlertMessage({
                            alertMessageType: 'error',
                            alertMessageText: 'Hiba történt az adatok lekérdezése közben. Kérjük, próbálja újra!'
                        }));
                        return;
                    }
    
                    const getModelsRes: AxiosResponse<GetModelsSuccessResponse> = getModelsResponse;

                    const _modelTreeInProcessEditor: ModelInModelTreeInProcessEditor[] = [];
                    const models: ModelWithLoaded[] = [];
                    for (const model of getModelsRes.data.models) {

                        _modelTreeInProcessEditor.push({
                            uuid: model.uuid,
                            name: model.name,
                            visible: model.visible,
                            position: [model.xPosition, model.yPosition, model.zPosition],
                            rotation: [model.xRotation, model.yRotation, model.zRotation],
                            scale: [model.xScale, model.yScale, model.zScale],
                            isPartOfAModel: false,
                            children: []
                        });

                        models.push({
                            ...model,
                            loaded: false
                        });
                    }
                    setModelTreeInProcessEditor(_modelTreeInProcessEditor);
                    setModelsInProcessEditor(models);
    
                    const getProcessStepsRes: AxiosResponse<GetProcessStepsSuccessResponse> = getProcessStepsResponse;
                    
                    const processStepsWithEndpointModel: typeof processSteps = [];
                    for (const processStep of getProcessStepsRes.data.processSteps) {
                        processStepsWithEndpointModel.push({
                            ...processStep,
                            processStepItems: processStep.processStepItems?.map(processStepItem => ({
                                ...processStepItem,
                                endpointModelUUID: (processStepItem.modelToBeMovedUUID && processStepItem.isModelToBeMovedVisible && processStepItem.hasTargetModel) ? THREE.MathUtils.generateUUID() : null,
                                done: processStepItem.modelToBeMovedUUID ? true : false
                            }))
                        });
                    }

                    setProcessSteps(processStepsWithEndpointModel);
                }
            };
            getData();

            return () => {
                ignore = true;
            };

        } else if (activeModelEditorType === 'layerEditor' && project.layerEditorModule) {
            
            resetLayerEditorData();

            const getData = async () => {
                showLoadingAlertMessage();

                if (project.workInstructionModule) {

                    const [getModelsResponse, getLayersResponse, getWorkinstructionsResponse] = await Promise.all([
                        networkCall(`/projects/${ project.id }/models`),
                        networkCall(`/projects/${ project.id }/layers`),
                        networkCall(`/projects/${ project.id }/work-instructions`)
                    ]);
    
                    dispatch(clearAlertMessage());

                    if (ignore) return;

                    if (getModelsResponse?.status !== 200 || getLayersResponse?.status !== 200 || getWorkinstructionsResponse?.status !== 200) {
                        dispatch(showAlertMessage({
                            alertMessageType: 'error',
                            alertMessageText: 'Hiba történt az adatok lekérdezése közben. Kérjük, próbálja újra!'
                        }));
                        return;
                    }

                    const getModelsRes: AxiosResponse<GetModelsSuccessResponse> = getModelsResponse;

                    const _modelTreeInLayerEditor: ModelInModelTreeInLayerEditor[] = [];
                    const models: ModelWithLoaded[] = [];
                    for (const model of getModelsRes.data.models) {

                        _modelTreeInLayerEditor.push({
                            uuid: model.uuid,
                            name: model.name,
                            visible: model.visible,
                            position: [model.xPosition, model.yPosition, model.zPosition],
                            rotation: [model.xRotation, model.yRotation, model.zRotation],
                            isPartOfAModel: false,
                            children: []
                        });

                        models.push({
                            ...model,
                            loaded: false
                        });
                    }
                    setModelTreeInLayerEditor(_modelTreeInLayerEditor);
                    setModelsInLayerEditor(models);
    
                    const getLyersRes: AxiosResponse<GetLayersSuccessResponse> = getLayersResponse;

                    const _layers: typeof layers = [];
                    for (const layer of getLyersRes.data.layers) {
                        _layers.push({
                            ...layer,
                            layerItems: layer.layerItems ?
                                layer.layerItems.map(layerItem => ({
                                    ...layerItem,
                                    changeableSubmodelName: false
                                })) :
                                []
                        });
                    }

                    setLayers(_layers);
    
                    const getWorkInstructionsRes: AxiosResponse<GetWorkInstructionsSuccessResponse> = getWorkinstructionsResponse;
                    const workInstructionsWithUUID: WorkInstructionWithUUIDs[] = [];
                    for (const workInstruction of getWorkInstructionsRes.data.workInstructions) {
                        workInstructionsWithUUID.push({
                            ...workInstruction,
                            POIUUID: THREE.MathUtils.generateUUID(),
                            POILineEndpointUUID: THREE.MathUtils.generateUUID()
                        });
                    }
                    setWorkInstructions(workInstructionsWithUUID);

                } else {

                    const [getModelsResponse, getLayersResponse] = await Promise.all([
                        networkCall(`/projects/${ project.id }/models`),
                        networkCall(`/projects/${ project.id }/layers`)
                    ]);
                    
                    dispatch(clearAlertMessage());

                    if (ignore) return;

                    if (getModelsResponse?.status !== 200 || getLayersResponse?.status !== 200) {
                        dispatch(showAlertMessage({
                            alertMessageType: 'error',
                            alertMessageText: 'Hiba történt az adatok lekérdezése közben. Kérjük, próbálja újra!'
                        }));
                        return;
                    }
    
                    const getModelsRes: AxiosResponse<GetModelsSuccessResponse> = getModelsResponse;

                    const _modelTreeInLayerEditor: ModelInModelTreeInLayerEditor[] = [];
                    const models: ModelWithLoaded[] = [];
                    for (const model of getModelsRes.data.models) {

                        _modelTreeInLayerEditor.push({
                            uuid: model.uuid,
                            name: model.name,
                            visible: model.visible,
                            position: [model.xPosition, model.yPosition, model.zPosition],
                            rotation: [model.xRotation, model.yRotation, model.zRotation],
                            isPartOfAModel: false,
                            children: []
                        });

                        models.push({
                            ...model,
                            loaded: false
                        });
                    }
                    setModelTreeInProcessEditor(_modelTreeInLayerEditor);
                    setModelsInProcessEditor(models);
    
                    const getLyersRes: AxiosResponse<GetLayersSuccessResponse> = getLayersResponse;

                    const _layers: typeof layers = [];
                    for (const layer of getLyersRes.data.layers) {
                        _layers.push({
                            ...layer,
                            layerItems: layer.layerItems ?
                                layer.layerItems.map(layerItem => ({
                                    ...layerItem,
                                    changeableSubmodelName: false
                                })) :
                                []
                        });
                    }

                    setLayers(_layers);
                }
            };
            getData();

            return () => {
                ignore = true;
            };
        }
    }, [activeModelEditorType, project, dispatch, navigate, updateModelTreeInModelSpace, resetModelSpaceData, resetProcessEditorData, resetLayerEditorData]);
    
    let needSave = false;

    if (
        areWorkInstructionsInModelSpaceChanged ||
        areModelsInModelSpaceChanged ||
        areProcessStepsInProcessEditorChanged ||
        areLayersInLayerEditorChanged
    ) needSave = true;

    if (activeModelEditorType !== prevActiveModelEditorType) {
        setPrevActiveModelEditorType(activeModelEditorType);

        if (activeModelEditorType === 'modelSpace') {
            setViewportShadingInModelSpace('solid');
        }
        setAreModelsInModelSpaceChanged(false);
        setAreWorkInstructionsInModelSpaceChanged(false);

        if (activeModelEditorType === 'processEditor') {
            setViewportShadingInProcessEditor('solid');
        }
        setAreProcessStepsInProcessEditorChanged(false);

        if (activeModelEditorType === 'layerEditor') {        
            setViewportShadingInLayerEditor('solid');
        }
        setAreLayersInLayerEditorChanged(false);
    }

    async function handleSave() {
        if (activeModelEditorType === 'modelSpace') {
            setSelectedModelUUIDInModelSpace(null);
            showLoadingAlertMessage();
            let savedSuccessfully = true;

            // visszaállítjuk az eredeti materialokat, hogy mentéskor azokat mentse
            resetMaterialsInModelSpace(modelTreeInModelSpace);

            let nextModels: ModelInModelTreeInModelSpace[] = [];
            for (const model of modelTreeInModelSpace) {
                nextModels.push({
                    ...model
                });

                let modifiedModel = undefined;
                if (modelSpaceRef.current) {
                    const modelToExport = modelSpaceRef.current.getModifiedModel(model.uuid);

                    if (modelToExport) {
                        const { GLTFExporter } = await import('three/addons/exporters/GLTFExporter.js');
                        const exporter = new GLTFExporter();

                        try {
                            const gltf = await exporter.parseAsync(modelToExport);
                            const blob = new Blob([JSON.stringify(gltf)], { type: 'text/plain' });
                            modifiedModel = new File([blob], `${model.name}.gltf`, { type: 'text/plain' });
                        } catch (error) {
                            
                        }
                    }
                }

                if (model.isRoot && model.id !== undefined) {
                    if (model.id < 0) { // új modell
                        const response = await networkCall(`/projects/${ project.id }/models`, {
                            method: 'POST',
                            requestBodyType: 'FILE_FORM',
                            body: {
                                uuid: model.uuid,
                                name: model.name,
                                visible: model.visible ? '1' : '0',
                                originalModel: model.originalModel,
                                modifiedModel,
                                xPosition: model.position[0],
                                yPosition: model.position[1],
                                zPosition: model.position[2],
                                xRotation: model.rotation[0],
                                yRotation: model.rotation[1],
                                zRotation: model.rotation[2],
                                xScale: model.scale[0],
                                yScale: model.scale[1],
                                zScale: model.scale[2]
                            }
                        });
                
                        if (response?.status === 201) {

                            const res: AxiosResponse<CreateModelSuccessResponse> = response;
                            nextModels = nextModels.map(_model => {
                                if (_model.id === model.id) {
                                    return  {
                                        ..._model,
                                        id: res.data.model.id
                                    };
                                } else return _model;
                            });

                        } else savedSuccessfully = false;

                    } else { // meglévő modell

                        const response = await networkCall(`/models/${ model.id }`, {
                            method: 'PUT',
                            requestBodyType: 'FILE_FORM',
                            body: {
                                name: model.name,
                                visible: model.visible ? '1' : '0',
                                modifiedModel,
                                xPosition: model.position[0],
                                yPosition: model.position[1],
                                zPosition: model.position[2],
                                xRotation: model.rotation[0],
                                yRotation: model.rotation[1],
                                zRotation: model.rotation[2],
                                xScale: model.scale[0],
                                yScale: model.scale[1],
                                zScale: model.scale[2]
                            }
                        });

                        if (response?.status !== 200) savedSuccessfully = false;

                    }
                }
            }

            updateModelTreeInModelSpace(nextModels);

            if (savedSuccessfully) {
                if (modelsUUIDsToDeleteInModelSpaceRef.current.size > 0) {
                    const uuidsArray: string[] = [];
                    modelsUUIDsToDeleteInModelSpaceRef.current.forEach(uuid => uuidsArray.push(uuid));

                    const response = await networkCall(`/projects/${ project.id }/models/batch-delete`, {
                        method: 'POST',
                        body: {
                            UUIDs: uuidsArray
                        }
                    });

                    if (!response || response.status !== 200) savedSuccessfully = false;
                    else modelsUUIDsToDeleteInModelSpaceRef.current = new Set<string>();
                }
                
            }

            if (savedSuccessfully) {
                for (const workInstruction of workInstructions) {
                    const response = await networkCall(`/work-instructions/${ workInstruction.id }`, {
                        method: 'PUT',
                        body: {
                            POIXPosition: workInstruction.POIXPosition,
                            POIYPosition: workInstruction.POIYPosition,
                            POIZPosition: workInstruction.POIZPosition,
                            POILineEndpointXPosition: workInstruction.POILineEndpointXPosition,
                            POILineEndpointYPosition: workInstruction.POILineEndpointYPosition,
                            POILineEndpointZPosition: workInstruction.POILineEndpointZPosition
                        }
                    });

                    if (!response || response.status !== 200) savedSuccessfully = false;
                }
            }

            dispatch(clearAlertMessage());

            switch (viewportShadingInModelSpace) {
                case 'normals':
                    setNormalMaterialToModelsInModelSpace(modelTreeInModelSpace);
                    break;
                case 'wireframe':
                    setWireframedMaterialToModelsInModelSpace(modelTreeInModelSpace);
                    break;
            }

            if (savedSuccessfully) {
                setAreWorkInstructionsInModelSpaceChanged(false);
                setAreModelsInModelSpaceChanged(false);

                dispatch(showAlertMessage({
                    alertMessageText: AlertMessages.SavedSuccessfully
                }));
            }
            else dispatch(showAlertMessage({
                alertMessageText: 'Valamely modell vagy POI mentése során hiba történt. Kérjük, próbálja újra!',
                alertMessageType: 'error'
            }));

        } else if (activeModelEditorType === 'processEditor') {

            showLoadingAlertMessage();
            setSelectedModelUUIDInProcessEditor(null);

            const validationData = validateProcessSteps(processSteps);

            if (validationData.valid === false) {
                setSelectedProcessStepItemIdInProcessEditor(validationData.processStepItemId);
                setSelectedProcessStepId(validationData.processStepId);

                dispatch(clearAlertMessage());
                dispatch(showAlertMessage({
                    alertMessageType: 'error',
                    alertMessageText: validationData.errorMessage
                }));

                return;
            }

            let savedSuccessfully = true;
            for (const processStep of processSteps) {
                if (processStep.id! < 0) { // új lépés
                    const createProcessStepResponse = await networkCall(`/projects/${ project.id }/process-steps`, {
                        method: 'POST',
                        body: {
                            name: processStep.name,
                            workInstructionId: null
                        }
                    });

                    if (createProcessStepResponse?.status === 201) {

                        const createProcessStepRes: AxiosResponse<CreateProcessStepSuccessResponse> = createProcessStepResponse;
                        
                        if (processStep.processStepItems && processStep.processStepItems.length > 0) {
                            for (const processStepItem of processStep.processStepItems) {
                                if (processStepItem.id < 0) {

                                    const createProcessStepItemResponse = await networkCall(`/process-steps/${ createProcessStepRes.data.processStep.id }/process-step-items`, {
                                        method: 'POST',
                                        body: {
                                            modelToBeMovedUUID: processStepItem.modelToBeMovedUUID,
                                            isModelToBeMovedVisible: processStepItem.isModelToBeMovedVisible,
                                            isModelToBeMovedConnectedToReferenceModel: processStepItem.isModelToBeMovedConnectedToReferenceModel,
                                            referenceModelUUID: processStepItem.referenceModelUUID,
                                            hasTargetModel: processStepItem.endpointModelUUID ? processStepItem.hasTargetModel : false,
                                            targetXPosition: processStepItem.targetXPosition,
                                            targetYPosition: processStepItem.targetYPosition,
                                            targetZPosition: processStepItem.targetZPosition,
                                            targetXRotation: processStepItem.targetXRotation,
                                            targetYRotation: processStepItem.targetYRotation,
                                            targetZRotation: processStepItem.targetZRotation,
                                            toolId: processStepItem.tool ? processStepItem.tool.id : undefined
                                        }
                                    });
                                    
                                    if (createProcessStepItemResponse?.status === 201) {
                                        const res: AxiosResponse<CreateProcessStepItemSuccessResponse> = createProcessStepItemResponse;

                                        setProcessSteps(prevProcessSteps => prevProcessSteps.map(
                                            prevPorcessStep => ({
                                                ...prevPorcessStep,
                                                processStepItems: prevPorcessStep.processStepItems?.map(
                                                    prevProcessStepItem => {
                                                        if (prevProcessStepItem.id === processStepItem.id) {
                                                            return {
                                                                ...prevProcessStepItem,
                                                                id: res.data.processStepItem.id
                                                            };
                                                        }

                                                        return prevProcessStepItem;
                                                    }
                                                )
                                            })
                                        ));
                                            
                                    } else savedSuccessfully = false;
                                } else {

                                    const updateProcessStepItemResponse = await networkCall(`/process-step-items/${ createProcessStepRes.data.processStep.id }`, {
                                        method: 'PUT',
                                        body: {
                                            modelToBeMovedUUID: processStepItem.modelToBeMovedUUID,
                                            isModelToBeMovedVisible: processStepItem.isModelToBeMovedVisible,
                                            isModelToBeMovedConnectedToReferenceModel: processStepItem.isModelToBeMovedConnectedToReferenceModel,
                                            referenceModelUUID: processStepItem.referenceModelUUID,
                                            hasTargetModel: processStepItem.endpointModelUUID ? processStepItem.hasTargetModel : false,
                                            targetXPosition: processStepItem.targetXPosition,
                                            targetYPosition: processStepItem.targetYPosition,
                                            targetZPosition: processStepItem.targetZPosition,
                                            targetXRotation: processStepItem.targetXRotation,
                                            targetYRotation: processStepItem.targetYRotation,
                                            targetZRotation: processStepItem.targetZRotation,
                                            toolId: processStepItem.tool ? processStepItem.tool.id : undefined
                                        }
                                    });

                                    if (updateProcessStepItemResponse?.status !== 200) savedSuccessfully = false;
                                }
                            }
                        }

                        setProcessSteps(prevProcessSteps => prevProcessSteps.map(
                            prevProcessStep => {
                                if (prevProcessStep.id === processStep.id) {
                                    return {
                                        ...prevProcessStep,
                                        id: createProcessStepRes.data.processStep.id
                                    };
                                }

                                return prevProcessStep;
                            }
                        ));

                    } else savedSuccessfully = false;
                } else { // meglévő lépés
                    const updateProcessStepResponse = await networkCall(`/process-steps/${ processStep.id }`, {
                        method: 'PUT',
                        body: {
                            name: processStep.name
                        }
                    });

                    if (updateProcessStepResponse?.status === 200) {
                        
                        if (processStep.processStepItems && processStep.processStepItems.length > 0) {
                            for (const processStepItem of processStep.processStepItems) {
                                if (processStepItem.id < 0) {

                                    const createProcessStepItemResponse = await networkCall(`/process-steps/${ processStep.id }/process-step-items`, {
                                        method: 'POST',
                                        body: {
                                            modelToBeMovedUUID: processStepItem.modelToBeMovedUUID,
                                            isModelToBeMovedVisible: processStepItem.isModelToBeMovedVisible,
                                            isModelToBeMovedConnectedToReferenceModel: processStepItem.isModelToBeMovedConnectedToReferenceModel,
                                            referenceModelUUID: processStepItem.referenceModelUUID,
                                            hasTargetModel: processStepItem.endpointModelUUID ? processStepItem.hasTargetModel : false,
                                            targetXPosition: processStepItem.targetXPosition,
                                            targetYPosition: processStepItem.targetYPosition,
                                            targetZPosition: processStepItem.targetZPosition,
                                            targetXRotation: processStepItem.targetXRotation,
                                            targetYRotation: processStepItem.targetYRotation,
                                            targetZRotation: processStepItem.targetZRotation,
                                            toolId: processStepItem.tool ? processStepItem.tool.id : undefined
                                        }
                                    });
                                    
                                    if (createProcessStepItemResponse?.status === 201) {
                                        const res: AxiosResponse<CreateProcessStepItemSuccessResponse> = createProcessStepItemResponse;

                                        setProcessSteps(prevProcessSteps => prevProcessSteps.map(
                                            prevPorcessStep => ({
                                                ...prevPorcessStep,
                                                processStepItems: prevPorcessStep.processStepItems?.map(
                                                    prevProcessStepItem => {
                                                        if (prevProcessStepItem.id === processStepItem.id) {
                                                            return {
                                                                ...prevProcessStepItem,
                                                                id: res.data.processStepItem.id
                                                            };
                                                        }

                                                        return prevProcessStepItem;
                                                    }
                                                )
                                            })
                                        ));
                                            
                                    } else savedSuccessfully = false;
                                } else {

                                    const updateProcessStepItemResponse = await networkCall(`/process-step-items/${ processStepItem.id }`, {
                                        method: 'PUT',
                                        body: {
                                            modelToBeMovedUUID: processStepItem.modelToBeMovedUUID,
                                            isModelToBeMovedVisible: processStepItem.isModelToBeMovedVisible,
                                            isModelToBeMovedConnectedToReferenceModel: processStepItem.isModelToBeMovedConnectedToReferenceModel,
                                            referenceModelUUID: processStepItem.referenceModelUUID,
                                            hasTargetModel: processStepItem.endpointModelUUID ? processStepItem.hasTargetModel : false,
                                            targetXPosition: processStepItem.targetXPosition,
                                            targetYPosition: processStepItem.targetYPosition,
                                            targetZPosition: processStepItem.targetZPosition,
                                            targetXRotation: processStepItem.targetXRotation,
                                            targetYRotation: processStepItem.targetYRotation,
                                            targetZRotation: processStepItem.targetZRotation,
                                            toolId: processStepItem.tool ? processStepItem.tool.id : undefined
                                        }
                                    });

                                    if (updateProcessStepItemResponse?.status !== 200) savedSuccessfully = false;
                                }
                            }
                        }

                    } else savedSuccessfully = false;
                }
            }

            for (const processStepItemId of processStepItemIdsToDeleteRef.current) {
                const response = await networkCall(`/process-step-items/${ processStepItemId }`, {
                    method: 'DELETE'
                });

                if (response?.status === 204) {
                    processStepItemIdsToDeleteRef.current = processStepItemIdsToDeleteRef.current.filter(_processStepItemId => processStepItemId !== _processStepItemId);
                }
                else savedSuccessfully = false;
            }

            for (const processStepId of processStepIdsToDeleteRef.current) {
                const response = await networkCall(`/process-steps/${ processStepId }`, {
                    method: 'DELETE'
                });
                if (response?.status === 204) {
                    processStepIdsToDeleteRef.current = processStepIdsToDeleteRef.current.filter(_processStepId => processStepId !== _processStepId);
                }
                else savedSuccessfully = false;
            }

            if (savedSuccessfully) {
                setAreProcessStepsInProcessEditorChanged(false);
                dispatch(showAlertMessage({
                    alertMessageText: AlertMessages.SavedSuccessfully
                }));
            } else dispatch(showAlertMessage({
                alertMessageText: 'Valamely lépés vagy lépéselem mentése során hiba történt. Kérjük, próbálja újra!',
                alertMessageType: 'error'
            }));

        } else if (activeModelEditorType === 'layerEditor') {

            showLoadingAlertMessage();
            setSelectedModelUUIDInLayerEditor(null);

            const validationData = validateLayers(layers);

            if (validationData.valid === false) {
                setSelectedLayerId(validationData.layerId);
                setSelectedLayerItemId(validationData.layerItemId);

                dispatch(clearAlertMessage());
                dispatch(showAlertMessage({
                    alertMessageType: 'error',
                    alertMessageText: validationData.errorMessage
                }));

                return;
            }

            let savedSuccessfully = true;

            for (const layer of layers) {
                if (layer.id < 0) { // még nem létező layer mentése
                    
                    const createLayerResponse = await networkCall(`/projects/${ project.id }/layers`, {
                        method: 'POST',
                        body: {
                            name: layer.name
                        }
                    });

                    if (createLayerResponse) {

                        if (createLayerResponse.status === 201) {
                            const createLayerRes: AxiosResponse<CreateLayerSuccessResponse> = createLayerResponse;

                            if (layer.layerItems) {
                                for (const layerItem of layer.layerItems) {
                                    const createLayerItemResponse = await networkCall(`/layers/${ createLayerRes.data.layer.id }/layer-items`, {
                                        method: 'POST',
                                        body: {
                                            name: layerItem.name,
                                            modelUUID: layerItem.modelUUID,
                                            modelXPosition: layerItem.modelXPosition,
                                            modelYPosition: layerItem.modelYPosition,
                                            modelZPosition: layerItem.modelZPosition,
                                            modelXRotation: layerItem.modelXRotation,
                                            modelYRotation: layerItem.modelYRotation,
                                            modelZRotation: layerItem.modelZRotation,
                                            submodelName: layerItem.submodelName ? layerItem.submodelName : undefined,
                                            submodelUUID: layerItem.submodelUUID ? layerItem.submodelUUID : undefined,
                                            submodelXPosition: layerItem.submodelXPosition,
                                            submodelYPosition: layerItem.submodelYPosition,
                                            submodelZPosition: layerItem.submodelZPosition,
                                            submodelXRotation: layerItem.submodelXRotation,
                                            submodelYRotation: layerItem.submodelYRotation,
                                            submodelZRotation: layerItem.submodelZRotation
                                        }
                                    });

                                    if (createLayerItemResponse && createLayerItemResponse.status === 201) {

                                        const createLayerItemRes: AxiosResponse<CreateLayerItemSuccessResponse> = createLayerItemResponse;

                                        setLayers(prevLayers => prevLayers.map(prevLayer => ({
                                            ...prevLayer,
                                            layerItems: prevLayer.layerItems ?
                                                prevLayer.layerItems.map(prevLayerItem => {
                                                    if (prevLayerItem.id === layerItem.id) {
                                                        return {
                                                            ...prevLayerItem,
                                                            id: createLayerItemRes.data.layerItem.id
                                                        };
                                                    } else return prevLayerItem;
                                                }) :
                                                []
                                        })));

                                    } else savedSuccessfully = false;
                                }
                            }

                            setLayers(prevLayers => prevLayers.map(prevLayer => {
                                if (prevLayer.id === layer.id) {
                                    return {
                                        ...prevLayer,
                                        id: createLayerRes.data.layer.id
                                    }
                                } else return prevLayer;
                            }));
                        } else savedSuccessfully = false;

                    } else savedSuccessfully = false;

                } else { // meglévő layer mentése

                    const updateLayerResponse = await networkCall(`/layers/${ layer.id }`, {
                        method: 'PUT',
                        body: {
                            name: layer.name
                        }
                    });

                    if (updateLayerResponse && updateLayerResponse.status === 200) {

                        if (layer.layerItems) {
                            for (const layerItem of layer.layerItems) {

                                if (layerItem.id < 0) { // új layer item

                                    const createLayerItemResponse = await networkCall(`/layers/${ layer.id }/layer-items`, {
                                        method: 'POST',
                                        body: {
                                            name: layerItem.name,
                                            modelUUID: layerItem.modelUUID,
                                            modelXPosition: layerItem.modelXPosition,
                                            modelYPosition: layerItem.modelYPosition,
                                            modelZPosition: layerItem.modelZPosition,
                                            modelXRotation: layerItem.modelXRotation,
                                            modelYRotation: layerItem.modelYRotation,
                                            modelZRotation: layerItem.modelZRotation,
                                            submodelName: layerItem.submodelName ? layerItem.submodelName : undefined,
                                            submodelUUID: layerItem.submodelUUID ? layerItem.submodelUUID : undefined,
                                            submodelXPosition: layerItem.submodelXPosition,
                                            submodelYPosition: layerItem.submodelYPosition,
                                            submodelZPosition: layerItem.submodelZPosition,
                                            submodelXRotation: layerItem.submodelXRotation,
                                            submodelYRotation: layerItem.submodelYRotation,
                                            submodelZRotation: layerItem.submodelZRotation
                                        }
                                    });

                                    if (createLayerItemResponse && createLayerItemResponse.status === 201) {

                                        const createLayerItemRes: AxiosResponse<CreateLayerItemSuccessResponse> = createLayerItemResponse;

                                        setLayers(prevLayers => prevLayers.map(prevLayer => ({
                                            ...prevLayer,
                                            layerItems: prevLayer.layerItems ?
                                                prevLayer.layerItems.map(prevLayerItem => {
                                                    if (prevLayerItem.id === layerItem.id) {
                                                        return {
                                                            ...prevLayerItem,
                                                            id: createLayerItemRes.data.layerItem.id
                                                        };
                                                    } else return prevLayerItem;
                                                }) :
                                                []
                                        })));

                                    } else savedSuccessfully = false;

                                } else { // meglévő layer item

                                    const updateLayerItemResponse = await networkCall(`/layer-items/${ layerItem.id }`, {
                                        method: 'PUT',
                                        body: {
                                            name: layerItem.name,
                                            modelUUID: layerItem.modelUUID,
                                            modelXPosition: layerItem.modelXPosition,
                                            modelYPosition: layerItem.modelYPosition,
                                            modelZPosition: layerItem.modelZPosition,
                                            modelXRotation: layerItem.modelXRotation,
                                            modelYRotation: layerItem.modelYRotation,
                                            modelZRotation: layerItem.modelZRotation,
                                            submodelName: layerItem.submodelName ? layerItem.submodelName : undefined,
                                            submodelUUID: layerItem.submodelUUID ? layerItem.submodelUUID : undefined,
                                            submodelXPosition: layerItem.submodelXPosition,
                                            submodelYPosition: layerItem.submodelYPosition,
                                            submodelZPosition: layerItem.submodelZPosition,
                                            submodelXRotation: layerItem.submodelXRotation,
                                            submodelYRotation: layerItem.submodelYRotation,
                                            submodelZRotation: layerItem.submodelZRotation
                                        }
                                    });

                                    if (!updateLayerItemResponse || updateLayerItemResponse.status !== 200) savedSuccessfully = false;

                                }
                            }
                        }
                        
                    } else savedSuccessfully = false;

                }
            }

            if (savedSuccessfully) {
                for (const layerItemId of layerItemIdsToDeleteRef.current) {
                    const response = await networkCall(`/layer-items/${ layerItemId }`, {
                        method: 'DELETE'
                    });

                    if (response?.status === 204) {
                        layerItemIdsToDeleteRef.current.delete(layerItemId);
                    } else savedSuccessfully = false;
                }
            }

            if (savedSuccessfully) {
                for (const layerId of layerIdsToDeleteRef.current) {
                    const response = await networkCall(`/layers/${ layerId }`, {
                        method: 'DELETE'
                    });

                    if (response?.status === 204) {
                        layerIdsToDeleteRef.current.delete(layerId);
                    } else savedSuccessfully = false;
                }
            }

            if (savedSuccessfully) {
                setAreLayersInLayerEditorChanged(false);
                dispatch(showAlertMessage({
                    alertMessageText: AlertMessages.SavedSuccessfully
                }));
            } else dispatch(showAlertMessage({
                alertMessageText: 'Valamely réteg vagy rétegelem során hiba történt. Kérjük, próbálja újra!',
                alertMessageType: 'error'
            }));
        }
    };

    // ------------------------------------
    // MODEL SPACE-HEZ ÉS EDITOR DATA VIEWER-BEN A MODEL SPACE-HEZ KAPCSOLÓDÓ DOLGOK
    //-------------------------------------

    if (viewportShadingInModelSpace !== prevViewportShadingInModelSpace) {
        setPrevViewportShadingInModelSpace(viewportShadingInModelSpace);
        
        switch (viewportShadingInModelSpace) {
            case 'solid':
                resetMaterialsInModelSpace(modelTreeInModelSpace);
                break;
            case 'normals':
                setNormalMaterialToModelsInModelSpace(modelTreeInModelSpace);
                break;
            case 'wireframe':
                setWireframedMaterialToModelsInModelSpace(modelTreeInModelSpace);
                break;
        }
    }

    function setNormalMaterialToModelsInModelSpace(modelTreeInModelSpace: ModelInModelTreeInModelSpace[]) {
        if (!modelSpaceRef.current) return;
        
        modelTreeInModelSpace.forEach(modelInModelTree => {
            if (!modelInModelTree.isRoot) modelSpaceRef.current?.setModelMaterial(modelInModelTree.uuid, new THREE.MeshNormalMaterial());
            
            if (modelInModelTree.children) setNormalMaterialToModelsInModelSpace(modelInModelTree.children);
        });
    }

    function resetMaterialsInModelSpace(modelTreeInModelSpace: ModelInModelTreeInModelSpace[]) {
        if (!modelSpaceRef.current) return;
        
        modelTreeInModelSpace.forEach(modelInModelTree => {
            if (!modelInModelTree.isRoot) modelSpaceRef.current?.setModelMaterial(modelInModelTree.uuid, modelInModelTree.originalMaterial ? modelInModelTree.originalMaterial : new THREE.MeshStandardMaterial());
            
            if (modelInModelTree.children) resetMaterialsInModelSpace(modelInModelTree.children);
        });
    }

    function setWireframedMaterialToModelsInModelSpace(modelTreeInModelSpace: ModelInModelTreeInModelSpace[]) {
        if (!modelSpaceRef.current) return;
        
        modelTreeInModelSpace.forEach(modelInModelTree => {
            if (!modelInModelTree.isRoot) modelSpaceRef.current?.setModelMaterial(modelInModelTree.uuid, new THREE.MeshBasicMaterial( { color: 0x000000, wireframe: true } ));
            
            if (modelInModelTree.children) setWireframedMaterialToModelsInModelSpace(modelInModelTree.children);
        });
    }

    function handleSelectModelWithDoubleClickInModelSpace(uuid: string) {
        setSelectedModelUUIDInModelSpace(uuid);

        if (modelSpaceRef.current && uuid) modelSpaceRef.current.zoomToModel(uuid);
    }

    function handleModelChangeInModelSpace(
        uuid: string,
        data: {
            xPosition?: number;
            yPosition?: number;
            zPosition?: number;
            xRotation?: number;
            yRotation?: number;
            zRotation?: number;
            xScale?: number;
            yScale?: number;
            zScale?: number;
        }
    ) {
        updateModelTreeInModelSpace(models => {
            const model = getModelFromModelTreeInModelSpaceByUUID(models, uuid);

            if (!model) return;
            
            let modified = false;
            if (data.xPosition !== undefined && data.xPosition !== model.position[0]) {
                model.position[0] = data.xPosition;
                modified = true;
            }
            
            if (data.yPosition !== undefined && data.yPosition !== model.position[1]) {
                model.position[1] = data.yPosition;
                modified = true;
            }

            if (data.zPosition !== undefined && data.zPosition !== model.position[2]) {
                model.position[2] = data.zPosition;
                modified = true;
            }
            
            if (data.xRotation !== undefined && data.xRotation !== model.rotation[0]) {
                model.rotation[0] = data.xRotation;
                modified = true;
            }
            
            if (data.yRotation !== undefined && data.yRotation !== model.rotation[1]) {
                model.rotation[1] = data.yRotation;
                modified = true;
            }
            
            if (data.zRotation !== undefined && data.zRotation !== model.rotation[2]) {
                model.rotation[2] = data.zRotation;
                modified = true;
            }
            
            if (data.xScale !== undefined && data.xScale !== model.scale[0]) {
                model.scale[0] = data.xScale;
                modified = true;
            }
            
            if (data.yScale !== undefined && data.yScale !== model.scale[1]) {
                model.scale[1] = data.yScale;
                modified = true;
            }
                
            if (data.zScale !== undefined && data.zScale !== model.scale[2]) {
                model.scale[2] = data.zScale;
                modified = true;
            }

            if (modified) {
                if (!model.isRoot) {
                    if (modelSpaceRef.current) modelSpaceRef.current.setModelData(uuid, {
                        ...data
                    });
                }

                setAreModelsInModelSpaceChanged(true);
            }
        });
    }

    function handleDeleteModelInModelSpace(uuid: string) {
        if (modelSpaceRef.current && modelSpaceRef.current.isPOI(uuid)) {
            setSelectedModelUUIDInModelSpace(uuid);
            return;
        }

        updateModelTreeInModelSpace(models => {
            const deletedModel = deleteModelFromModelTreeInModelSpaceByUUID(models, uuid);
            if (deletedModel) {
                setAreModelsInModelSpaceChanged(true);

                if (modelSpaceRef.current) {
                    const uuidsToDelete = modelSpaceRef.current.getUUIDsOfAModelAndItsChildren(uuid);
                    uuidsToDelete.forEach(_uuid => modelsUUIDsToDeleteInModelSpaceRef.current.add(_uuid));

                    modelSpaceRef.current.deleteByUUID(uuid);
                }
            }
        });

    }

    function handleAddNewModelInModelSpace(file: File) {
        const uuid = THREE.MathUtils.generateUUID();
        const id = newModelIdRef.current--;
        const name = file.name;

        setAreModelsInModelSpaceChanged(true);

        updateModelTreeInModelSpace(models => {
            models.push({
                id,
                uuid,
                visible: true,
                name,
                originalModel: file,
                modifiedModel: file,
                isRoot: true,
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                scale: [1, 1, 1],
                loaded: false,
                children: []
            });
        });
    }

    function handlePOIChange(uuid: string, data: {
        POIXPosition?: number;
        POIYPosition?: number;
        POIZPosition?: number;
    }) {
        setWorkInstructions(workInstructions.map(workInstruction => {
            if (workInstruction.POIUUID === uuid) {
                if (
                    (data.POIXPosition !== undefined && data.POIXPosition !== workInstruction.POIXPosition) ||
                    (data.POIYPosition !== undefined && data.POIYPosition !== workInstruction.POIYPosition) ||
                    (data.POIZPosition !== undefined && data.POIZPosition !== workInstruction.POIZPosition)
                ) setAreWorkInstructionsInModelSpaceChanged(true);
                
                return {
                    ...workInstruction,
                    ...data
                };
            }
            else return workInstruction;
        }));
    };

    function handlePOILineEndpointChange(uuid: string, data: {
        POILineEndpointXPosition?: number;
        POILineEndpointYPosition?: number;
        POILineEndpointZPosition?: number;
    }) {
        setWorkInstructions(workInstructions.map(workInstruction => {
            if (workInstruction.POILineEndpointUUID === uuid) {
                if (
                    (data.POILineEndpointXPosition !== undefined && data.POILineEndpointXPosition !== workInstruction.POILineEndpointXPosition) ||
                    (data.POILineEndpointYPosition !== undefined && data.POILineEndpointYPosition !== workInstruction.POILineEndpointYPosition) ||
                    (data.POILineEndpointZPosition !== undefined && data.POILineEndpointZPosition !== workInstruction.POILineEndpointZPosition)
                ) setAreWorkInstructionsInModelSpaceChanged(true);
                
                return {
                    ...workInstruction,
                    ...data
                };
            } else return workInstruction;
        }));
    }

    function handleModelLoadedInModelSpace(uuid: string, successfullyLoaded: boolean, children?: ModelInModelTreeInModelSpace[]) {
        updateModelTreeInModelSpace(models => {
            for (const model of models) {
                if (model.uuid === uuid) {
                    model.loaded = true;
                    if (children) {
                        model.children = children;

                        setTimeout(() => {
                            switch (viewportShadingInModelSpace) {
                                case 'solid':
                                    resetMaterialsInModelSpace(children);
                                    break;
                                case 'normals':
                                    setNormalMaterialToModelsInModelSpace(children);
                                    break;
                                case 'wireframe':
                                    setWireframedMaterialToModelsInModelSpace(children);
                                    break;
                            }
                        }, 100);
                    }
                    
                    break;
                }
            }
        });
    };

    function handleModelNameChangeInModelSpace(uuid: string, name: string) {
        updateModelTreeInModelSpace(models => {
            const model = getModelFromModelTreeInModelSpaceByUUID(models, uuid);

            if (model && model.name !== name) {
                model.name = name;
                setAreModelsInModelSpaceChanged(true);

                if (!model.isRoot && modelSpaceRef.current) modelSpaceRef.current.renameModel(uuid, name);
            }
        });
    };

    function handleVisibleChangeInModelSpace(uuid: string, visible: boolean) {
        updateModelTreeInModelSpace(models => {
            const model = getModelFromModelTreeInModelSpaceByUUID(models, uuid);

            if (model && model.visible !== visible) {
                model.visible = visible;
                setAreModelsInModelSpaceChanged(true);

                if (!model.isRoot && modelSpaceRef.current) modelSpaceRef.current.changeModelvisibility(uuid, visible);
            }
        });
    }

    // ------------------------------------
    // PROCESS EDITOR-HOZ ÉS EDITOR DATA VIEWER-BEN A PROCESS EDITOR-HOZ KAPCSOLÓDÓ DOLGOK
    //-------------------------------------

    if (prevSelectedProcessStepId !== selectedProcessStepId) {
        setPrevSelectedProcessStepId(selectedProcessStepId);
        if (selectedProcessStepId === null) {
            setSelectedModelUUIDInProcessEditor(null);
            setSelectedProcessStepItemIdInProcessEditor(null);
        }
    }

    if (processEditorActionStatus !== prevProcessEditorActionStatus) {
        setPrevProcessEditorActionStatus(processEditorActionStatus);

        if (processEditorActionStatus === 'settingEndpointModel') {
            skipModelChangeInProcessEditorRef.current = false;
        }
    }

    if (prevSelectedProcessStepItemIdInProcessEditor !== selectedProcessStepItemIdInProcessEditor) {
        setPrevSelectedProcessStepItemIdInProcessEditor(selectedProcessStepItemIdInProcessEditor);

        setSelectedModelUUIDInProcessEditor(null);

        skipModelChangeInProcessEditorRef.current = true;

        setModelTreeInProcessEditor(originalModelTreeInProcessEditorRef.current);
        
        setTimeout(() => {
            rebuildOriginalModelHierarchyInProcessEditor(originalModelTreeInProcessEditorRef.current);
            setOriginalPositionAndRotationAndScaleForProcessEditorModels(originalModelTreeInProcessEditorRef.current);

            // minden "modelToBeMoved" láthatóságok visszaállítása a térben true-ra
            for (const processStep of processSteps) {
                
                if (processStep.processStepItems) {
                    for (const processStepItem of processStep.processStepItems) {
                        if (processStepItem.modelToBeMovedUUID) {
                            const model = getModelFromModelTreeInPorcessEditorByUUID(processStepItem.modelToBeMovedUUID, modelTreeInProcessEditor);
                            if (!model) continue;

                            if (model.isPartOfAModel) {

                                if (processEditorRef.current) {
                                    processEditorRef.current.changeModelvisibility(processStepItem.modelToBeMovedUUID, true);
                                }

                            } else {

                                setModelsInProcessEditor(prevModels => prevModels.map(
                                    prevModel => {
                                        if (prevModel.uuid === processStepItem.modelToBeMovedUUID) {
                                            return {
                                                ...prevModel,
                                                visible: true
                                            };
                                        } else {
                                            return prevModel;
                                        }
                                    }
                                ));

                            }
                        }
                    }
                }
                
            }

            if (selectedProcessStepItemIdInProcessEditor !== null) {

                // "elemek" (modelToBeMoved) láthatóságainak(isModelToBeMovedVisible) beállítása az adott lépésig
                for (const processStep of processSteps) {
                    let processStepItemFound = false;

                    if (processStep.processStepItems) {
                        for (const processStepItem of processStep.processStepItems) {
                            
                            if (processStepItem.modelToBeMovedUUID && !processStepItem.isModelToBeMovedVisible) {
                                const model = getModelFromModelTreeInPorcessEditorByUUID(processStepItem.modelToBeMovedUUID, modelTreeInProcessEditor);
                                if (!model) continue;

                                if (model.isPartOfAModel) {

                                    if (processEditorRef.current) {
                                        processEditorRef.current.changeModelvisibility(processStepItem.modelToBeMovedUUID, false);
                                    }

                                } else {

                                    setModelsInProcessEditor(prevModels => prevModels.map(
                                        prevModel => {
                                            if (prevModel.uuid === processStepItem.modelToBeMovedUUID) {
                                                return {
                                                    ...prevModel,
                                                    visible: false
                                                };
                                            } else {
                                                return prevModel;
                                            }
                                        }
                                    ));

                                }
                            }

                            if (selectedProcessStepItemIdInProcessEditor === processStepItem.id) {
                                processStepItemFound = true;
                                break;
                            }
                        }
                    }

                    if (processStepItemFound) break;
                }

                // "elemek"(modelToBeMoved) összekapcsolása a hozzá tartozó referenciamodellhez
                // a process editor-ban(térben) és a model tree-ben, illetve a target pozíciók és rotációk beállítása
                let prevProcessStepItem:
                    null |
                    ProcessStepItemWithEndpointModelAndDoneAndStartingModelNameAndReferenceModelName |
                    NewProcessStepItemWithEndpointModelAndDoneAndStartingModelNameAndReferenceModelName = null;
                let isCurrentProcessStepItemReached = false;
                let _modelTree = _.cloneDeep(originalModelTreeInProcessEditorRef.current);

                for (const processStep of processSteps) {
                    
                    if (processStep.processStepItems) {
                        for (const processStepItem of processStep.processStepItems) {

                            if (prevProcessStepItem && prevProcessStepItem.modelToBeMovedUUID && prevProcessStepItem.isModelToBeMovedVisible) {
                                
                                const model = getModelFromModelTreeInPorcessEditorByUUID(prevProcessStepItem.modelToBeMovedUUID, originalModelTreeInProcessEditorRef.current);
                                if (model) {

                                    if (model.isPartOfAModel) {

                                        processEditorRef.current?.setWorldPositionAndRotationAsLocalByUUID(
                                            prevProcessStepItem.modelToBeMovedUUID,
                                            new THREE.Vector3(prevProcessStepItem.targetXPosition, prevProcessStepItem.targetYPosition, prevProcessStepItem.targetZPosition),
                                            new THREE.Euler(prevProcessStepItem.targetXRotation, prevProcessStepItem.targetYRotation, prevProcessStepItem.targetZRotation)
                                        );
                                        
                                    } else {

                                        processEditorRef.current?.setModelPositionAndRotation(
                                            prevProcessStepItem.modelToBeMovedUUID,
                                            [prevProcessStepItem.targetXPosition, prevProcessStepItem.targetYPosition, prevProcessStepItem.targetZPosition],
                                            [prevProcessStepItem.targetXRotation, prevProcessStepItem.targetYRotation, prevProcessStepItem.targetZRotation]
                                        );

                                    }

                                    if (prevProcessStepItem.referenceModelUUID && prevProcessStepItem.isModelToBeMovedConnectedToReferenceModel) {
                                        
                                        processEditorRef.current?.attachToParent(prevProcessStepItem.modelToBeMovedUUID, prevProcessStepItem.referenceModelUUID);

                                        const { node, parent } = findNodeAndParentInModelTreeInProcessEditor(_modelTree, prevProcessStepItem.modelToBeMovedUUID, null);

                                        if (node) {
                                            if (prevProcessStepItem?.referenceModelUUID) {
                                                
                                                if (parent) {
                                                    parent.children = parent.children.filter(model => model.uuid !== prevProcessStepItem?.modelToBeMovedUUID);
                                                } else {
                                                    _modelTree = _modelTree.filter(model => model.uuid !== prevProcessStepItem?.modelToBeMovedUUID);
                                                }

                                                const { node: newParent } = findNodeAndParentInModelTreeInProcessEditor(_modelTree, prevProcessStepItem.referenceModelUUID);

                                                if (newParent) {
                                                    newParent.children.push({
                                                        ...node,
                                                        isPartOfAModel: true
                                                    });
                                                }
                                            }
                                        }
                                    }

                                }
                                
                            }

                            prevProcessStepItem = processStepItem;

                            if (processStepItem.id === selectedProcessStepItemIdInProcessEditor) {
                                
                                // státusz beállítása a process step item aktuális állapotának megfelelően
                                if (processStepItem.done) setProcessEditorActionStatus('done');
                                else {
                                    if (!processStepItem.modelToBeMovedUUID) setProcessEditorActionStatus('clickOnStartingPointMenuItem');
                                    else if (!processStepItem.referenceModelUUID) setProcessEditorActionStatus('selectingReferenceModel');
                                    else if (!processStepItem.endpointModelUUID) setProcessEditorActionStatus('clickOnEndpointMenuItem');
                                    else if (!processStepItem.tool) setProcessEditorActionStatus('selectingTool');
                                    else if (!processStepItem.done) setProcessEditorActionStatus('clickToDone');
                                    else setProcessEditorActionStatus('done');
                                }
                                
                                isCurrentProcessStepItemReached = true;
                                break;
                            }
                        }
                    }

                    if (isCurrentProcessStepItemReached) {
                        break;
                    }
                }

                setModelTreeInProcessEditor(_modelTree);
            }
        }, 0);
    }

    if (areProcessEditorModelsLoading !== prevAreProcessEditorModelsLoading) {
        setPrevAreProcessEditorModelsLoading(areProcessEditorModelsLoading);

        if (!areProcessEditorModelsLoading) {
            // ha minden modell betöltött, akkor a process step item-ek starting modelljének és referencia modelljének neveit beállítjuk
            setTimeout(() => {
                setProcessSteps(prevProcessSteps => prevProcessSteps.map(
                    prevProcessStep => ({
                        ...prevProcessStep,
                        processStepItems: prevProcessStep.processStepItems?.map(
                            prevProcessStepItem => {
                                if (prevProcessStepItem.modelToBeMovedUUID || prevProcessStepItem.referenceModelUUID) {
                                    return {
                                        ...prevProcessStepItem,
                                        startingModelName: prevProcessStepItem.modelToBeMovedUUID ? getModelFromModelTreeInPorcessEditorByUUID(prevProcessStepItem.modelToBeMovedUUID, originalModelTreeInProcessEditorRef.current)?.name : undefined,
                                        referenceModelName: prevProcessStepItem.referenceModelUUID ? getModelFromModelTreeInPorcessEditorByUUID(prevProcessStepItem.referenceModelUUID, originalModelTreeInProcessEditorRef.current)?.name : undefined
                                    };
                                }

                                return prevProcessStepItem;
                            }
                        )
                    })
                ));
            }, 0);
        }
    }

    if (viewportShadingInProcessEditor !== prevViewportShadingInProcessEditor) {
        setPrevViewportShadingInProcessEditor(viewportShadingInProcessEditor);
        
        switch (viewportShadingInProcessEditor) {
            case 'solid':
                resetMaterialsInProcessEditor(originalModelTreeInProcessEditorRef.current ?? modelTreeInProcessEditor);
                break;
            case 'normals':
                setNormalMaterialToModelsInProcessEditor(originalModelTreeInProcessEditorRef.current ?? modelTreeInProcessEditor);
                break;
            case 'wireframe':
                setWireframedMaterialToModelsInProcessEditor(originalModelTreeInProcessEditorRef.current ?? modelTreeInProcessEditor);
                break;
        }
    }

    let enableTransformControlsOnSelectedModelInProcessEditor = true;
    if (
        processEditorActionStatus === 'selectingStartingModel' ||
        processEditorActionStatus === 'selectingReferenceModel'
    ) {
        enableTransformControlsOnSelectedModelInProcessEditor = false;
    }

    function setNormalMaterialToModelsInProcessEditor(modelTreeInProcessEditor: ModelInModelTreeInProcessEditor[]) {
        if (!processEditorRef.current) return;
        
        modelTreeInProcessEditor.forEach(modelInModelTree => {
            if (modelInModelTree.isPartOfAModel) processEditorRef.current?.setModelMaterial(modelInModelTree.uuid, new THREE.MeshNormalMaterial());
            
            if (modelInModelTree.children) setNormalMaterialToModelsInProcessEditor(modelInModelTree.children);
        });
    }

    function resetMaterialsInProcessEditor(modelTreeInProcessEditor: ModelInModelTreeInProcessEditor[]) {
        if (!processEditorRef.current) return;
        
        modelTreeInProcessEditor.forEach(modelInModelTree => {
            if (modelInModelTree.isPartOfAModel) processEditorRef.current?.setModelMaterial(modelInModelTree.uuid, modelInModelTree.originalMaterial ? modelInModelTree.originalMaterial : new THREE.MeshStandardMaterial());
            
            if (modelInModelTree.children) resetMaterialsInProcessEditor(modelInModelTree.children);
        });
    }

    function setWireframedMaterialToModelsInProcessEditor(modelTreeInProcessEditor: ModelInModelTreeInProcessEditor[]) {
        if (!processEditorRef.current) return;
        
        modelTreeInProcessEditor.forEach(modelInModelTree => {
            if (modelInModelTree.isPartOfAModel) processEditorRef.current?.setModelMaterial(modelInModelTree.uuid, new THREE.MeshBasicMaterial( { color: 0x000000, wireframe: true } ));
            
            if (modelInModelTree.children) setWireframedMaterialToModelsInProcessEditor(modelInModelTree.children);
        });
    }

    function setOriginalPositionAndRotationAndScaleForProcessEditorModels(originalModels: ModelInModelTreeInProcessEditor[]) {
        originalModels.forEach(model => {
            if (processEditorRef.current) {
                processEditorRef.current.setModelPositionAndRotation(model.uuid, model.position, model.rotation);
                processEditorRef.current.setModelScale(model.uuid, model.scale);
            }

            if (model.children) setOriginalPositionAndRotationAndScaleForProcessEditorModels(model.children);
        });
    }

    function validateProcessSteps(_processSteps: typeof processSteps): {
        valid: true;
    } | {
        valid: false;
        errorMessage: string;
        processStepId: number;
        processStepItemId: number;
    } {
        for (const processStep of _processSteps) {
            if (processStep.processStepItems && processStep.processStepItems.length > 0) {
                for (const processStepItem of processStep.processStepItems) {

                    if (!processStepItem.modelToBeMovedUUID) {
                        return {
                            valid: false,
                            errorMessage: 'Elem megadása kötelező.',
                            processStepId: processStep.id!,
                            processStepItemId: processStepItem.id
                        };
                    }

                    if (
                        processStepItem.referenceModelUUID &&
                        processStepItem.modelToBeMovedUUID === processStepItem.referenceModelUUID
                    ) {
                        return {
                            valid: false,
                            errorMessage: 'Elem és referenciamodell nem lehet ugyanaz a modell.',
                            processStepId: processStep.id!,
                            processStepItemId: processStepItem.id
                        };
                    }

                    if (
                        (!processStepItem.modelToBeMovedUUID &&
                        processStepItem.referenceModelUUID &&
                        processStepItem.isModelToBeMovedConnectedToReferenceModel) ||
                        (processStepItem.modelToBeMovedUUID &&
                        !processStepItem.isModelToBeMovedVisible &&
                        processStepItem.referenceModelUUID &&
                        processStepItem.isModelToBeMovedConnectedToReferenceModel)
                    ) {
                        return {
                            valid: false,
                            errorMessage: 'Ha nincs "elem" kiválasztva, nem lehet összekapcsolva a referenciamodellel.',
                            processStepId: processStep.id!,
                            processStepItemId: processStepItem.id
                        };
                    }

                }
            }
        }

        return {
            valid: true
        };
    }

    function handleModelLoadedInProcessEditor(successfullyLoaded: boolean, model: ModelInModelTreeInProcessEditor) {
        setModelsInProcessEditor(prevModels => prevModels.map(_model => {
            if (_model.uuid === model.uuid)
                return {
                    ..._model,
                    loaded: true
                };
            else return _model;
        }));

        if (successfullyLoaded) {
            setModelTreeInProcessEditor(
                prevModels => {
                    let isExistingModel = false;
                    let nextModels = prevModels.map(_model => {
                        if (_model.uuid === model.uuid) {
                            isExistingModel = true;
                            return model;
                        } else return _model;
                    });
    
                    if (!isExistingModel) return [
                        ...prevModels,
                        model
                    ];
    
                    return nextModels;
                }
            );

            if (!originalModelTreeInProcessEditorRef.current.find(_model => _model.uuid === model.uuid)) {
                originalModelTreeInProcessEditorRef.current.push(model);
            }
        }
    }

    function handleAddNewProcessStep(id: number, name: string) {
        const processStep = processSteps.find(processStep => processStep.id === id);
        
        if (!processStep) {
            setProcessSteps(prevProcessSteps => [...prevProcessSteps, {
                id,
                name,
                order: null
            }]);

            setAreProcessStepsInProcessEditorChanged(true);
        }
            

        setSelectedProcessStepId(id);
    }

    function handleAddNewProcessStepItem(id: number, processStepId: number) {
        const processStep = processSteps.find(processStep => processStep.id === processStepId);

        if (processStep) {
            const processStepItem = processStep.processStepItems?.find(processStepItem => processStepItem.id === id);

            if (!processStepItem) {
                if (processStep.processStepItems)
                    processStep.processStepItems = [...processStep.processStepItems, {
                        id,
                        modelToBeMovedUUID: null,
                        isModelToBeMovedVisible: true,
                        isModelToBeMovedConnectedToReferenceModel: false,
                        hasTargetModel: false,
                        referenceModelUUID: null,
                        targetXPosition: 0,
                        targetYPosition: 0,
                        targetZPosition: 0,
                        targetXRotation: 0,
                        targetYRotation: 0,
                        targetZRotation: 0,
                        endpointModelUUID: null,
                        done: false
                    }];
                else processStep.processStepItems = [{
                    id,
                    modelToBeMovedUUID: null,
                    isModelToBeMovedVisible: true,
                    isModelToBeMovedConnectedToReferenceModel: false,
                    referenceModelUUID: null,
                    hasTargetModel: false,
                    targetXPosition: 0,
                    targetYPosition: 0,
                    targetZPosition: 0,
                    targetXRotation: 0,
                    targetYRotation: 0,
                    targetZRotation: 0,
                    endpointModelUUID: null,
                    done: false
                }];
            }

            setAreProcessStepsInProcessEditorChanged(true);

            setSelectedProcessStepId(processStepId);
            setSelectedProcessStepItemIdInProcessEditor(id);
        }
    }

    function handleModelChangeInProcessEditor(uuid: string, data:
        {
            xPosition: number;
            yPosition: number;
            zPosition: number;
            xRotation: number;
            yRotation: number;
            zRotation: number;
        }
    ) {
        if (skipModelChangeInProcessEditorRef.current) return;

        if (processEditorActionStatus === 'settingEndpointModel') {
            if (selectedProcessStepItemIdInProcessEditor !== null) {
                setProcessSteps(prevProcessSteps => prevProcessSteps.map(prevProcessStep => ({
                    ...prevProcessStep,
                    processStepItems: prevProcessStep.processStepItems?.map(prevProcessStepItem => {
                        if (prevProcessStepItem.id === selectedProcessStepItemIdInProcessEditor) {
                            if (prevProcessStepItem.endpointModelUUID === uuid) {

                                if (
                                    prevProcessStepItem.targetXPosition !== data.xPosition ||
                                    prevProcessStepItem.targetYPosition !== data.yPosition ||
                                    prevProcessStepItem.targetZPosition !== data.zPosition ||
                                    prevProcessStepItem.targetXRotation !== data.xRotation ||
                                    prevProcessStepItem.targetYRotation !== data.yRotation ||
                                    prevProcessStepItem.targetZRotation !== data.zRotation
                                ) {
                                    setAreProcessStepsInProcessEditorChanged(true);

                                    return {
                                        ...prevProcessStepItem,
                                        done: false,
                                        targetXPosition: data.xPosition,
                                        targetYPosition: data.yPosition,
                                        targetZPosition: data.zPosition,
                                        targetXRotation: data.xRotation,
                                        targetYRotation: data.yRotation,
                                        targetZRotation: data.zRotation
                                    };
                                } else return prevProcessStepItem;
                                
                            } else return prevProcessStepItem;
                        } else return prevProcessStepItem;
                    })
                })));
            }
        }
    }

    function handleProcessStepNameChange(processStepId: number, name: string) {
        setProcessSteps(prevProcessSteps => {
            let found = false;
            for (const processStep of prevProcessSteps) {
                if (processStepId === processStep.id) {
                    found = true;
                    break;
                }
            }

            if (found) return prevProcessSteps.map(processStep => {
                if (processStep.id === processStepId && name !== processStep.name) {
                    setAreProcessStepsInProcessEditorChanged(true);

                    return {
                        ...processStep,
                        name
                    };
                }
                else return processStep;
            });

            return prevProcessSteps;
        });
    }

    function handleProcessStepDelete(processStepId: number) {
        let deletable = false;
        for (const processStep of processSteps) {
            if (processStep.id === processStepId) {
                // ha van order, az azt jelenti, hogy nem tartozik munkautasításhoz, tehát törölhető
                if (processStepId < 0 || processStep.order) deletable = true;
                break;
            }
        }
        
        if (deletable) {
            if (processStepId > 0 && !processStepIdsToDeleteRef.current.includes(processStepId))
                processStepIdsToDeleteRef.current.push(processStepId);

            setProcessSteps(prevProcessSteps => prevProcessSteps.filter(processStep => processStep.id !== processStepId));
            setAreProcessStepsInProcessEditorChanged(true);
        }
    }

    function handleProcessStepItemDelete(processStepItemId: number) {
        let found = false;
        let processStepIndex: number | null = null;
        let processStepItemIndex: number | null = null;
        for (let i = 0; i < processSteps.length; i++) {
            if (processSteps[i].processStepItems) {
                for (let j = 0; j < processSteps[i].processStepItems!.length; j++) {
                    if (processSteps[i].processStepItems![j].id === processStepItemId) {
                        found = true;
                        processStepIndex = i;
                        processStepItemIndex = j;
                        break;
                    }
                }
            }

            if (found) break;
        }

        if (found && processStepIndex !== null && processStepItemIndex !== null) {
            const _processSteps: typeof processSteps = JSON.parse(JSON.stringify(processSteps));
            _processSteps[processStepIndex].processStepItems?.splice(processStepItemIndex, 1);
            setProcessSteps(_processSteps);

            if (processStepItemId > 0 && !processStepItemIdsToDeleteRef.current.includes(processStepItemId))
                processStepItemIdsToDeleteRef.current.push(processStepItemId);

            if (processStepItemId === selectedProcessStepItemIdInProcessEditor) setSelectedProcessStepItemIdInProcessEditor(null);

            setAreProcessStepsInProcessEditorChanged(true);
        }
    }

    function handleModelSelectInProcessEditor(uuid: string | null) {
        if (uuid) {
            const isModelVisible = processEditorRef.current?.getModelvisibility(uuid);
            if (!isModelVisible) return;
        }

        if (selectedProcessStepId === null) {
            setSelectedModelUUIDInProcessEditor(uuid);
            return;
        }

        if (uuid === null) return;

        if (processEditorActionStatus === 'selectingStartingModel') {
            let isProcessStepItemFound = false;

            for (const processStep of processSteps) {
                const currentSelectedProcessStepItem = processStep.processStepItems?.find(processStepItem => processStepItem.id === selectedProcessStepItemIdInProcessEditor);

                if (!currentSelectedProcessStepItem) {
                    continue;
                }

                if (currentSelectedProcessStepItem.modelToBeMovedUUID === uuid) {
                    return;
                }

                isProcessStepItemFound = true;

                if (currentSelectedProcessStepItem.referenceModelUUID === uuid) {
                    dispatch(clearAlertMessage());
                    dispatch(showAlertMessage({
                        alertMessageText: '"Elem" nem lehet ugyanaz, mint a referenciamodell.',
                        alertMessageType: 'error'
                    }));
                    return;
                }

                if (
                    currentSelectedProcessStepItem.referenceModelUUID &&
                    currentSelectedProcessStepItem.isModelToBeMovedConnectedToReferenceModel &&
                    isAncestorInModelTreeInProcessEditor(currentSelectedProcessStepItem.referenceModelUUID, uuid, modelTreeInProcessEditor)
                ) {
                    dispatch(clearAlertMessage());
                    dispatch(showAlertMessage({
                        alertMessageText: 'Referenciamodellnek nem lehet őse az "Elem" modell, ha össze vannak kapcsolva.',
                        alertMessageType: 'error'
                    }));
                    return;
                }
            }

            if (!isProcessStepItemFound) {
                return;
            }

            setAreProcessStepsInProcessEditorChanged(true);
            setSelectedModelUUIDInProcessEditor(uuid);
            setProcessSteps(prevProcessSteps => prevProcessSteps.map(prevProcessStep => ({
                ...prevProcessStep,
                processStepItems: prevProcessStep.processStepItems?.map(prevProcessStepItem => {
                    if (prevProcessStepItem.id === selectedProcessStepItemIdInProcessEditor) {
                        // az előzőleg kiválasztott "elem" modell visszaállítása láthatóvá
                        if (prevProcessStepItem.modelToBeMovedUUID) {
                            const model = getModelFromModelTreeInPorcessEditorByUUID(prevProcessStepItem.modelToBeMovedUUID, modelTreeInProcessEditor);
                            if (model) {
                                if (model.isPartOfAModel) {

                                    processEditorRef.current?.changeModelvisibility(prevProcessStepItem.modelToBeMovedUUID, true);
                                
                                } else {

                                    setModelsInProcessEditor(prevModels => prevModels.map(
                                        prevModel => {
                                            if (prevModel.uuid === prevProcessStepItem.modelToBeMovedUUID) {
                                                return {
                                                    ...prevModel,
                                                    visible: true
                                                };
                                            } else {
                                                return prevModel;
                                            }
                                        }
                                    ));

                                }
                            }
                        }

                        const model = getModelFromModelTreeInPorcessEditorByUUID(uuid, originalModelTreeInProcessEditorRef.current);
                                
                        if (model) {
                            return {
                                ...prevProcessStepItem,
                                modelToBeMovedUUID: uuid,
                                startingModelName: model.name,
                                hasTargetModel: false,
                                endpointModelUUID: null,
                                done: false
                            };
                        }

                        return {
                            ...prevProcessStepItem,
                            modelToBeMovedUUID: uuid,
                            hasTargetModel: false,
                            endpointModelUUID: null,
                            done: false
                        };
                    } else return prevProcessStepItem;
                })
            })));
        } else if (processEditorActionStatus === 'selectingReferenceModel') {
            let isProcessStepItemFound = false;

            for (const processStep of processSteps) {
                const currentSelectedProcessStepItem = processStep.processStepItems?.find(processStepItem => processStepItem.id === selectedProcessStepItemIdInProcessEditor);

                if (!currentSelectedProcessStepItem) {
                    continue;
                }

                isProcessStepItemFound = true;

                if (currentSelectedProcessStepItem.modelToBeMovedUUID === uuid) {
                    dispatch(clearAlertMessage());
                    dispatch(showAlertMessage({
                        alertMessageText: 'Referenciamodell nem lehet ugyanaz, mint az "Elem".',
                        alertMessageType: 'error'
                    }));
                    return;
                }

                if (
                    currentSelectedProcessStepItem.modelToBeMovedUUID &&
                    currentSelectedProcessStepItem.isModelToBeMovedConnectedToReferenceModel &&
                    isAncestorInModelTreeInProcessEditor(uuid, currentSelectedProcessStepItem.modelToBeMovedUUID, modelTreeInProcessEditor)
                ) {
                    dispatch(clearAlertMessage());
                    dispatch(showAlertMessage({
                        alertMessageText: 'Referenciamodellnek nem lehet őse az "Elem" modell, ha össze vannak kapcsolva.',
                        alertMessageType: 'error'
                    }));
                    return;
                }
            }

            if (!isProcessStepItemFound) {
                return;
            }

            setSelectedModelUUIDInProcessEditor(uuid);
            setProcessSteps(prevProcessSteps => prevProcessSteps.map(processStep => ({
                ...processStep,
                processStepItems: processStep.processStepItems?.map(processStepItem => {
                    if (processStepItem.id === selectedProcessStepItemIdInProcessEditor) {
                        const model = getModelFromModelTreeInPorcessEditorByUUID(uuid, originalModelTreeInProcessEditorRef.current);

                        if (model) {
                            return {
                                ...processStepItem,
                                referenceModelUUID: uuid,
                                referenceModelName: model.name
                            };
                        }

                        return {
                            ...processStepItem,
                            referenceModelUUID: uuid
                        };
                    } else return processStepItem;
                })
            })));
        }
    }

    function handleProcessStepItemStartingModelClick(processStepItemId: number) {
        for (const processStep of processSteps) {
            const processStepItem = processStep.processStepItems?.find(processStepItem => processStepItem.id === processStepItemId);
            if (processStepItem) {
                setProcessEditorActionStatus('selectingStartingModel');

                if (processStepItem.modelToBeMovedUUID && processStepItem.isModelToBeMovedVisible) {

                    setSelectedModelUUIDInProcessEditor(processStepItem.modelToBeMovedUUID);

                } else {
                    setSelectedModelUUIDInProcessEditor(null);
                }
                
                return;
            }
        }
    }

    function handleSettingProcessStepItemStartingModelVisible(processStepItemId: number, visible: boolean) {
        for (const processStep of processSteps) {
            const processStepItem = processStep.processStepItems?.find(processStepItem => processStepItem.id === processStepItemId);
            if (!processStepItem) {
                continue;
            }

            if (!processStepItem.modelToBeMovedUUID || processStepItem.isModelToBeMovedVisible === visible) {
                return;
            }

            setAreProcessStepsInProcessEditorChanged(true);
            setProcessSteps(prevProcessSteps => prevProcessSteps.map(
                prevProcessStep => ({
                    ...prevProcessStep,
                    processStepItems: prevProcessStep.processStepItems ?
                        prevProcessStep.processStepItems.map(prevProcessStepItem => {
                            if (prevProcessStepItem.id === processStepItemId) {
                                return {
                                    ...prevProcessStepItem,
                                    isModelToBeMovedVisible: visible,
                                    isModelToBeMovedConnectedToReferenceModel: visible ? prevProcessStepItem.isModelToBeMovedConnectedToReferenceModel : false,
                                    hasTargetModel: visible ? prevProcessStepItem.hasTargetModel : false,
                                    endpointModelUUID: visible ? prevProcessStepItem.endpointModelUUID : null,
                                    done: false
                                };
                            } else {
                                return prevProcessStepItem;
                            }
                        }) :
                        []
                })
            ));

            const model = getModelFromModelTreeInPorcessEditorByUUID(processStepItem.modelToBeMovedUUID, modelTreeInProcessEditor);
            if (!model) break;
            
            if (model.isPartOfAModel) {
                if (processEditorRef.current) {
                    processEditorRef.current.changeModelvisibility(processStepItem.modelToBeMovedUUID, visible);
                }
            } else {
                setModelsInProcessEditor(prevModels => prevModels.map(
                    prevModel => {
                        if (prevModel.uuid === processStepItem.modelToBeMovedUUID) {
                            return {
                                ...prevModel,
                                visible
                            };
                        } else {
                            return prevModel;
                        }
                    }
                ));
            }

            if (visible) {
                setProcessEditorActionStatus('selectingStartingModel');
                setSelectedModelUUIDInProcessEditor(processStepItem.modelToBeMovedUUID);
            } else {
                setSelectedModelUUIDInProcessEditor(null);
            }

            break;
        }
    }

    function handleSettingProcessStepItemModelToBeMovedConnectedToReferenceModel(processStepItemId: number, connected: boolean) {
        for (const processStep of processSteps) {
            const processStepItem = processStep.processStepItems?.find(processStepItem => processStepItem.id === processStepItemId);
            if (!processStepItem) {
                continue;
            }

            if (
                !processStepItem.modelToBeMovedUUID ||
                !processStepItem.isModelToBeMovedVisible ||
                !processStepItem.referenceModelUUID
            ) {
                return;
            }

            if (connected === processStepItem.isModelToBeMovedConnectedToReferenceModel) {
                return;
            }

            if (
                connected &&
                isAncestorInModelTreeInProcessEditor(processStepItem.referenceModelUUID, processStepItem.modelToBeMovedUUID, modelTreeInProcessEditor)
            ) {
                dispatch(clearAlertMessage());
                dispatch(showAlertMessage({
                    alertMessageText: 'Referenciamodellnek nem lehet őse az "Elem" modell.',
                    alertMessageType: 'error'
                }));
                return;
            }

            setAreProcessStepsInProcessEditorChanged(true);
            setProcessSteps(prevProcessSteps => prevProcessSteps.map(
                prevProcessStep => ({
                    ...prevProcessStep,
                    processStepItems: prevProcessStep.processStepItems ?
                        prevProcessStep.processStepItems.map(prevProcessStepItem => {
                            if (prevProcessStepItem.id === processStepItemId) {
                                return {
                                    ...prevProcessStepItem,
                                    isModelToBeMovedConnectedToReferenceModel: connected,
                                    done: false
                                };
                            } else {
                                return prevProcessStepItem;
                            }
                        }) :
                        []
                })
            ));

            return;
        }
    }

    function handleProcessStepItemReferenceModelClick(processStepItemId: number) {
        for (const processStep of processSteps) {
            const processStepItem = processStep.processStepItems?.find(processStepItem => processStepItem.id === processStepItemId);
            if (processStepItem) {
                setProcessEditorActionStatus('selectingReferenceModel');
                
                if (processStepItem.referenceModelUUID) {
                    setSelectedModelUUIDInProcessEditor(processStepItem.referenceModelUUID);
                } else {
                    setSelectedModelUUIDInProcessEditor(null);
                }
                
                return;
            }
        }
    }

    function handleToolChooseForProcessStepItem(processStepItemId: number, tool: Tool) {
        setProcessSteps(prevProcessSteps => prevProcessSteps.map(prevProcessStep => ({
            ...prevProcessStep,
            processStepItems: prevProcessStep.processStepItems?.map(prevProcessStepItem => {
                if (prevProcessStepItem.id === processStepItemId) {
                    setProcessEditorActionStatus('clickOnEndpointMenuItem');

                    if (prevProcessStepItem.tool?.id !== tool.id) {
                        setAreProcessStepsInProcessEditorChanged(true);

                        return {
                            ...prevProcessStepItem,
                            done: false,
                            tool
                        };
                    }
                }
                return prevProcessStepItem;
            })
        })));
    }

    function handleToolDeleteForProcessStepItem(processStepItemId: number) {
        setProcessSteps(prevProcessSteps => prevProcessSteps.map(prevProcessStep => ({
            ...prevProcessStep,
            processStepItems: prevProcessStep.processStepItems?.map(prevProcessStepItem => {
                if (prevProcessStepItem.id === processStepItemId) {
                    setProcessEditorActionStatus('selectingTool');
                    
                    if (prevProcessStepItem.tool) {
                        setAreProcessStepsInProcessEditorChanged(true);
                        return {
                            ...prevProcessStepItem,
                            done: false,
                            tool: undefined
                        };
                    }
                }
                return prevProcessStepItem;
            })
        })));
    }
    
    function handleProcessStepItemEndpointModelClick(processStepItemId: number) {
        for (const processStep of processSteps) {
            const processStepItem = processStep.processStepItems?.find(processStepItem => processStepItem.id === processStepItemId);
            if (processStepItem) {

                if (!processStepItem.modelToBeMovedUUID) {
                    return;
                }
                
                if (!processStepItem.isModelToBeMovedVisible) {
                    dispatch(clearAlertMessage());
                    dispatch(showAlertMessage({
                        alertMessageType: 'error',
                        alertMessageText: 'Az "elem" nem látható, nem generálhat "elem végpontot. A generáláshoz tegye láthatóvá a szem ikonnak.'
                    }));
                    return;
                } 

                setProcessEditorActionStatus('settingEndpointModel');

                if (!processStepItem.hasTargetModel) {
                    setProcessSteps(prevProcessSteps => prevProcessSteps.map((prevProcessStep) => ({
                        ...prevProcessStep,
                        processStepItems: prevProcessStep.processStepItems?.map((prevProcessStepItem) => {
                            if (prevProcessStepItem.id === processStepItemId) {
                                return {
                                    ...prevProcessStepItem,
                                    hasTargetModel: true
                                };
                            } else return prevProcessStepItem;
                        })
                    })));
                    setAreProcessStepsInProcessEditorChanged(true);
                }

                if (processStepItem.endpointModelUUID) {
                    setSelectedModelUUIDInProcessEditor(processStepItem.endpointModelUUID);
                } else {
                    setAreProcessStepsInProcessEditorChanged(true);
                    setProcessSteps(prevProcessSteps => prevProcessSteps.map((prevProcessStep) => ({
                        ...prevProcessStep,
                        processStepItems: prevProcessStep.processStepItems?.map((prevProcessStepItem) => {
                            if (prevProcessStepItem.id === processStepItemId) {
                                const endpointModelUUID = THREE.MathUtils.generateUUID();
                                
                                setTimeout(() => setSelectedModelUUIDInProcessEditor(endpointModelUUID), 0);

                                if (processEditorRef.current) {
                                    const posAndRot = processEditorRef.current.getModelWorldPositionAndRotationByUUID(prevProcessStepItem.modelToBeMovedUUID as string);

                                    if (posAndRot) {
                                        return {
                                            ...prevProcessStepItem,
                                            endpointModelUUID,
                                            targetXPosition: posAndRot.position.x + 0.5,
                                            targetYPosition: posAndRot.position.y + 0.5,
                                            targetZPosition: posAndRot.position.z + 0.5,
                                            targetXRotation: posAndRot.rotation.x,
                                            targetYRotation: posAndRot.rotation.y,
                                            targetZRotation: posAndRot.rotation.z
                                        };
                                    }
                                }

                                return {
                                    ...prevProcessStepItem,
                                    endpointModelUUID,
                                    targetXPosition: 0,
                                    targetYPosition: 0,
                                    targetZPosition: 0,
                                    targetXRotation: 0,
                                    targetYRotation: 0,
                                    targetZRotation: 0
                                };
                                
                            } else return prevProcessStepItem;
                        })
                    })));
                }
                
                return;
            }
        }
    }

    function handleProcessStepItemEndpointDeleteClick(processStepItemId: number) {
        for (const processStep of processSteps) {
            const processStepItem = processStep.processStepItems?.find(processStepItem => processStepItem.id === processStepItemId);
            if (processStepItem) {

                if (!processStepItem.hasTargetModel && !processStepItem.endpointModelUUID) {
                    return;
                }

                if (processEditorActionStatus === 'settingEndpointModel') {
                    setSelectedModelUUIDInProcessEditor(null);

                    if (!processStepItem.modelToBeMovedUUID) setProcessEditorActionStatus('clickOnStartingPointMenuItem');
                    else if (!processStepItem.referenceModelUUID) setProcessEditorActionStatus('selectingReferenceModel');
                    else if (!processStepItem.endpointModelUUID) setProcessEditorActionStatus('clickOnEndpointMenuItem');
                    else if (!processStepItem.tool) setProcessEditorActionStatus('selectingTool');
                    else setProcessEditorActionStatus('clickToDone');
                }

                setAreProcessStepsInProcessEditorChanged(true);

                setProcessSteps(prevProcessSteps => prevProcessSteps.map((prevProcessStep) => ({
                    ...prevProcessStep,
                    processStepItems: prevProcessStep.processStepItems?.map((prevProcessStepItem) => {
                        if (prevProcessStepItem.id === processStepItemId) {
                            return {
                                ...prevProcessStepItem,
                                hasTargetModel: false,
                                endpointModelUUID: null,
                                done: false
                            };
                        } else return prevProcessStepItem;
                    })
                })));
                setAreProcessStepsInProcessEditorChanged(true);
                
                return;
            }
        }
    }

    function handleProcessStepItemDoneClick(processStepItemId: number) {
        for (const processStep of processSteps) {
            const processStepItem = processStep.processStepItems?.find(processStepItem => processStepItem.id === processStepItemId);
            if (processStepItem) {
                if (!processStepItem.modelToBeMovedUUID || processStepItem.done) {
                    return;
                }
                
                setProcessEditorActionStatus('done');
                setSelectedModelUUIDInProcessEditor(null);
                setProcessSteps(prevProcessSteps => prevProcessSteps.map((prevProcessStep) => ({
                    ...prevProcessStep,
                    processStepItems: prevProcessStep.processStepItems?.map((prevProcessStepItem) => {
                        if (prevProcessStepItem.id === processStepItemId) {

                            return {
                                ...prevProcessStepItem,
                                done: true
                            };
                            
                        } else return prevProcessStepItem;
                    })
                })));
                break;
            }
        }
    }

    function handleModelSelectWithDoubleClickInProcessEditorModelTree(uuid: string) {
        handleModelSelectInProcessEditor(uuid);
        if (processEditorRef.current) processEditorRef.current.zoomToModel(uuid);
    }

    function rebuildOriginalModelHierarchyInProcessEditor(originalModelTree: ModelInModelTreeInProcessEditor[]) {
        if (!processEditorRef.current) return;
        
        function attachChildren(model: ModelInModelTreeInProcessEditor, parentObj: THREE.Object3D) {
            const obj = processEditorRef.current?.getModelByUUID(model.uuid);
            
            if (!obj) {
                return;
            }

            if (obj.parent !== parentObj) {
                parentObj.add(obj);
            }

            model.children.forEach(child => attachChildren(child, obj));
        }

        const scene = processEditorRef.current.getScene();
        if (scene) {
             originalModelTree.forEach(model => attachChildren(model, scene));
        }
    }

    // ------------------------------------
    // LAYER EDITOR-HOZ ÉS EDITOR DATA VIEWER-BEN AZ LAYER EDITOR-HOZ KAPCSOLÓDÓ DOLGOK
    //-------------------------------------
    if (selectedLayerId !== prevSelectedLayerId) {
        setPrevSelectedLayerId(selectedLayerId);
        setSelectedModelUUIDInLayerEditor(null);
        setSelectedLayerItemId(null);
    }

    if (layerEditorActionStatus !== prevLayerEditorActionStatus) {
        setPrevLayerEditorActionStatus(layerEditorActionStatus);

        if (layerEditorActionStatus === 'settingModel' ||
            layerEditorActionStatus === 'settingSubmodel'
        ) {
            skipModelChangeInLayerEditorRef.current = false;
        }
    }

    if (selectedLayerItemId !== prevSelectedLayerItemId) {
        setPrevSelectedLayerItemId(selectedLayerItemId);

        skipModelChangeInLayerEditorRef.current = true;

        setTimeout(() => {
            setOriginalPositionAndRotationForLayerEditorModels(modelTreeInLayerEditor);

            if (selectedLayerItemId === null) setSelectedModelUUIDInLayerEditor(null);
            else { // beállítjuk a kiválasztott layer item "model" és "submodel" állapotait
                for (const layer of layers) {
                    const layerItem = layer.layerItems?.find(_layerItem => _layerItem.id === selectedLayerItemId);

                    if (layerItem) {

                        if (!layerItem.modelUUID) setLayerEditorActionStatus('nameTheLayerItemThenClickOnSelectModel');
                        else if (!layerItem.submodelUUID) setLayerEditorActionStatus('selectingSubmodel');
                        else if (!layerItem.submodelName) setLayerEditorActionStatus('clickOnSubmodelName');
                        else setLayerEditorActionStatus('nameTheLayerItemThenClickOnSelectModel');

                        if (layerItem.modelUUID) {
                            const model = getModelFromModelTreeInPorcessEditorByUUID(layerItem.modelUUID, modelTreeInLayerEditor);

                            if (model) {
                                if (model.isPartOfAModel) { // nem gyökérmodell

                                    if (layerEditorRef.current) {
                                        layerEditorRef.current.setModelPositionAndRotation(
                                            model.uuid,
                                            [
                                                layerItem.modelXPosition,
                                                layerItem.modelYPosition,
                                                layerItem.modelZPosition
                                            ],
                                            [
                                                layerItem.modelXRotation,
                                                layerItem.modelYRotation,
                                                layerItem.modelZRotation
                                            ]
                                        );
                                    }

                                } else { // gyökérmodell, vagyis state-en keresztül állítjuk
                                    setTimeout(() => {
                                        setModelsInLayerEditor(prevModels => prevModels.map(prevModel => {
                                            if (prevModel.uuid === layerItem.modelUUID) {
                                                return {
                                                    ...prevModel,
                                                    xPosition: layerItem.modelXPosition,
                                                    yPosition: layerItem.modelYPosition,
                                                    zPosition: layerItem.modelZPosition,
                                                    xRotation: layerItem.modelXRotation,
                                                    yRotation: layerItem.modelYRotation,
                                                    zRotation: layerItem.modelZRotation
                                                };
                                            }

                                            return prevModel;
                                        }));
                                    }, 0);
                                }
                            }
                        }

                        if (layerItem.submodelUUID) {
                            const model = getModelFromModelTreeInPorcessEditorByUUID(layerItem.submodelUUID, modelTreeInLayerEditor);

                            if (model) {
                                if (model.isPartOfAModel) { // nem gyökérmodell

                                    if (layerEditorRef.current) {
                                        layerEditorRef.current.setModelPositionAndRotation(
                                            model.uuid,
                                            [
                                                layerItem.submodelXPosition,
                                                layerItem.submodelYPosition,
                                                layerItem.submodelZPosition
                                            ],
                                            [
                                                layerItem.submodelXRotation,
                                                layerItem.submodelYRotation,
                                                layerItem.submodelZRotation
                                            ]
                                        );
                                    }

                                } else { // gyökérmodell, vagyis state-en keresztül állítjuk
                                    setTimeout(() => {
                                        setModelsInLayerEditor(prevModels => prevModels.map(prevModel => {
                                            if (prevModel.uuid === layerItem.submodelUUID) {
                                                return {
                                                    ...prevModel,
                                                    xPosition: layerItem.submodelXPosition,
                                                    yPosition: layerItem.submodelYPosition,
                                                    zPosition: layerItem.submodelZPosition,
                                                    xRotation: layerItem.submodelXRotation,
                                                    yRotation: layerItem.submodelYRotation,
                                                    zRotation: layerItem.submodelZRotation
                                                };
                                            }

                                            return prevModel;
                                        }));
                                    }, 0);
                                }
                            }
                        }
                        
                        break;
                    }
                }
            }
        }, 0);

        // a "bezárt" (előző) layer item "changeableSubmodelName" false-ra állítása
        if (prevSelectedLayerItemId !== null) {
            for (const layer of layers) {
                const layerItem = layer.layerItems?.find(_layerItem => _layerItem.id === prevSelectedLayerItemId);

                if (layerItem) {

                    setLayers(prevLayers => prevLayers.map(prevLayer => ({
                        ...prevLayer,
                        layerItems: prevLayer.layerItems?.map(prevLayerItem => {
                            if (prevLayerItem.id === prevSelectedLayerItemId) {
                                return {
                                    ...prevLayerItem,
                                    changeableSubmodelName: false
                                };
                            }

                            return prevLayerItem;
                        })
                    })));

                    break;
                }
            }
        }
    }

    if (viewportShadingInLayerEditor !== prevViewportShadingInLayerEditor) {
        setPrevViewportShadingInLayerEditor(viewportShadingInLayerEditor);
        
        switch (viewportShadingInLayerEditor) {
            case 'solid':
                resetMaterialsInLayerEditor(modelTreeInLayerEditor);
                break;
            case 'normals':
                setNormalMaterialToModelsInLayerEditor(modelTreeInLayerEditor);
                break;
            case 'wireframe':
                setWireframedMaterialToModelsInLayerEditor(modelTreeInLayerEditor);
                break;
        }
    }

    function setNormalMaterialToModelsInLayerEditor(modelTreeInLayerEditor: ModelInModelTreeInLayerEditor[]) {
        if (!layerEditorRef.current) return;
        
        modelTreeInLayerEditor.forEach(modelInModelTree => {
            if (modelInModelTree.isPartOfAModel) layerEditorRef.current?.setModelMaterial(modelInModelTree.uuid, new THREE.MeshNormalMaterial());
            
            if (modelInModelTree.children) setNormalMaterialToModelsInLayerEditor(modelInModelTree.children);
        });
    }

    function resetMaterialsInLayerEditor(modelTreeInLayerEditor: ModelInModelTreeInLayerEditor[]) {
        if (!layerEditorRef.current) return;
        
        modelTreeInLayerEditor.forEach(modelInModelTree => {
            if (modelInModelTree.isPartOfAModel) layerEditorRef.current?.setModelMaterial(modelInModelTree.uuid, modelInModelTree.originalMaterial ? modelInModelTree.originalMaterial : new THREE.MeshStandardMaterial());
            
            if (modelInModelTree.children) resetMaterialsInLayerEditor(modelInModelTree.children);
        });
    }

    function setWireframedMaterialToModelsInLayerEditor(modelTreeInLayerEditor: ModelInModelTreeInLayerEditor[]) {
        if (!layerEditorRef.current) return;
        
        modelTreeInLayerEditor.forEach(modelInModelTree => {
            if (modelInModelTree.isPartOfAModel) layerEditorRef.current?.setModelMaterial(modelInModelTree.uuid, new THREE.MeshBasicMaterial( { color: 0x000000, wireframe: true } ));
            
            if (modelInModelTree.children) setWireframedMaterialToModelsInLayerEditor(modelInModelTree.children);
        });
    }

    function setOriginalPositionAndRotationForLayerEditorModels(originalModels: ModelInModelTreeInProcessEditor[]) {
        originalModels.forEach(model => {

            // ha gyökérmodellről van szó, akkor state-en keresztül állítjuk a pozíciót és rotációt
            if (modelsInLayerEditor.find(_model => _model.uuid === model.uuid)) {
                setModelsInLayerEditor(prevModels => {
                    return prevModels.map(prevModel => {
                        if (prevModel.uuid === model.uuid) {
                            return {
                                ...prevModel,
                                xPosition: model.position[0],
                                yPosition: model.position[1],
                                zPosition: model.position[2],
                                xRotation: model.rotation[0],
                                yRotation: model.rotation[1],
                                zRotation: model.rotation[2]
                            };
                        }
                        return prevModel;
                    });
                });
            } else {

                if (layerEditorRef.current)
                        layerEditorRef.current.setModelPositionAndRotation(model.uuid, model.position, model.rotation);

            }

            if (model.children) setOriginalPositionAndRotationForLayerEditorModels(model.children);
        });
    };

    function handleModelSelectInLayerEditor(uuid: string | null) {
        if (selectedLayerId === null) {
            setSelectedModelUUIDInLayerEditor(uuid);
            return;
        }
        
        if (uuid === null) return;

        if (layerEditorActionStatus === 'selectingModel') {
            setSelectedModelUUIDInLayerEditor(uuid);
            setLayerEditorActionStatus('settingModel');

            setLayers(prevLayers => prevLayers.map(prevLayer => ({
                ...prevLayer,
                layerItems: prevLayer.layerItems?.map(prevLayerItem => {
                    if (prevLayerItem.id === selectedLayerItemId) {
                        if (layerEditorRef.current) {
                            const modelData = layerEditorRef.current.getModelData(uuid);

                            if (modelData) {
                                return {
                                    ...prevLayerItem,
                                    modelUUID: uuid,
                                    modelXPosition: modelData.xPosition ? modelData.xPosition : 0,
                                    modelYPosition: modelData.yPosition ? modelData.yPosition : 0,
                                    modelZPosition: modelData.zPosition ? modelData.zPosition : 0,
                                    modelXRotation: modelData.xRotation ? modelData.xRotation : 0,
                                    modelYRotation: modelData.yRotation ? modelData.yRotation : 0,
                                    modelZRotation: modelData.zRotation ? modelData.zRotation : 0
                                };
                            }
                        }

                        return {
                            ...prevLayerItem,
                            modelUUID: uuid,
                            modelXPosition: 0,
                            modelYPosition: 0,
                            modelZPosition: 0,
                            modelXRotation: 0,
                            modelYRotation: 0,
                            modelZRotation: 0
                        };
                    } else return prevLayerItem;
                })
            })));
        } else if (layerEditorActionStatus === 'selectingSubmodel') {
            setSelectedModelUUIDInLayerEditor(uuid);
            setLayerEditorActionStatus('settingSubmodel');

            setLayers(prevLayers => prevLayers.map(prevLayer => ({
                ...prevLayer,
                layerItems: prevLayer.layerItems?.map(prevLayerItem => {
                    if (prevLayerItem.id === selectedLayerItemId) {
                        if (layerEditorRef.current) {
                            const modelData = layerEditorRef.current.getModelData(uuid);

                            if (modelData) {
                                return {
                                    ...prevLayerItem,
                                    submodelUUID: uuid,
                                    submodelXPosition: modelData.xPosition ? modelData.xPosition : 0,
                                    submodelYPosition: modelData.yPosition ? modelData.yPosition : 0,
                                    submodelZPosition: modelData.zPosition ? modelData.zPosition : 0,
                                    submodelXRotation: modelData.xRotation ? modelData.xRotation : 0,
                                    submodelYRotation: modelData.yRotation ? modelData.yRotation : 0,
                                    submodelZRotation: modelData.zRotation ? modelData.zRotation : 0
                                };
                            }
                        }

                        return {
                            ...prevLayerItem,
                            submodelUUID: uuid,
                            submodelXPosition: 0,
                            submodelYPosition: 0,
                            submodelZPosition: 0,
                            submodelXRotation: 0,
                            submodelYRotation: 0,
                            submodelZRotation: 0
                        };
                    } else return prevLayerItem;
                })
            })));
        }
    };

    function handleModelLoadedInLayerEditor(successfullyLoaded: boolean, model: ModelInModelTreeInLayerEditor) {
        setModelsInLayerEditor(prevModels => prevModels.map(_model => {
            if (_model.uuid === model.uuid)
                return {
                    ..._model,
                    loaded: true
                };
            else return _model;
        }));

        if (successfullyLoaded) {
            setModelTreeInLayerEditor(
                prevModels => {
                    let isExistingModel = false;
                    let nextModels = prevModels.map(_model => {
                        if (_model.uuid === model.uuid) {
                            isExistingModel = true;
                            return model;
                        } else return _model;
                    });
    
                    if (!isExistingModel) return [
                        ...prevModels,
                        model
                    ];
    
                    return nextModels;
                }
            );
        }
    };

    function handleNewLayerAdd(id: number, name: string) {
        const layer = layers.find(layer => layer.id === id);

        if (!layer) {
            setLayers([
                ...layers,
                {
                    id,
                    name
                }
            ]);

            setAreLayersInLayerEditorChanged(true);
        }
        
        setSelectedLayerId(id);
    };

    function handleNewLayerItemAdd(id: number, layerId: number, name: string) {
        let layerItemFound = false;
        for (const layer of layers) {
            if (layer.layerItems) {
                for (const layerItem of layer.layerItems) {
                    if (layerItem.id === id) {
                        layerItemFound = true;
                        break;
                    }
                }
            }
            if (layerItemFound) break;
        }

        if (!layerItemFound) {
            const newLayerItem: NewLayerItemWithChangeableSubmodelName = {
                id,
                name,
                modelUUID: null,
                modelXPosition: 0,
                modelYPosition: 0,
                modelZPosition: 0,
                modelXRotation: 0,
                modelYRotation: 0,
                modelZRotation: 0,
                submodelName: '',
                changeableSubmodelName: false,
                submodelUUID: null,
                submodelXPosition: 0,
                submodelYPosition: 0,
                submodelZPosition: 0,
                submodelXRotation: 0,
                submodelYRotation: 0,
                submodelZRotation: 0
            };

            setLayers(prevLayers => prevLayers.map(
                prevLayer => {
                    if (prevLayer.id === layerId) {
                        return {
                            ...prevLayer,
                            layerItems: prevLayer?.layerItems ?
                                [...prevLayer.layerItems, newLayerItem] :
                                [newLayerItem]
                        };
                    } else return prevLayer;
                }
            ));
        }

        setSelectedLayerItemId(id);
        setSelectedLayerId(layerId);
    }

    function handleLayerNameChange(layerId: number, name: string) {
        const layer = layers.find(layer => (layer.id === layerId && layer.name !== name));

        if (layer) {
            setLayers(prevLayers => prevLayers.map(_layer => {
                if (_layer.id === layerId)
                    return {
                        ..._layer,
                        name
                    };
                else return _layer;
            }));
        }
    }

    function handleLayerDelete(layerId: number) {
        const layer = layers.find(layer => layer.id === layerId);

        if (layer) {
            setLayers(prevLayers => prevLayers.filter(_layer => _layer.id !== layerId));
            setAreLayersInLayerEditorChanged(true);

            if (selectedLayerId === layerId) {
                setSelectedLayerId(null);
                setSelectedLayerItemId(null);
            }
            // layer > 0 - már az adatbázisban is létező layer
            if (layerId > 0 && layerIdsToDeleteRef.current && !layerIdsToDeleteRef.current.has(layerId))
                layerIdsToDeleteRef.current.add(layerId);
        }    
    }

    function handleLayerItemDelete(layerItemId: number) {
        for (const layer of layers) {
            const layerItem = layer.layerItems?.find(layerItem => layerItem.id === layerItemId);
            if (layerItem) {
                setLayers(prevLayers => prevLayers.map(
                    prevLayer => ({
                        ...prevLayer,
                        layerItems: prevLayer.layerItems ? prevLayer.layerItems.filter(layerItem => layerItem.id !== layerItemId) : []
                    })
                ));
                setAreLayersInLayerEditorChanged(true);

                if (layerItemId > 0 && layerItemIdsToDeleteRef.current && !layerItemIdsToDeleteRef.current.has(layerItemId))
                    layerItemIdsToDeleteRef.current.add(layerItemId);

                break;
            }
        }
    }

    function handleLayerItemNameChange(layerItemId: number, name: string) {
        for (const layer of layers) {
            const layerItem = layer.layerItems?.find(layerItem => layerItem.id === layerItemId);

            if (layerItem) {
                if (layerItem.name !== name) {
                    setLayers(prevLayers => prevLayers.map(
                        prevLayer => ({
                            ...prevLayer,
                            layerItems: prevLayer.layerItems?.map(
                                _layerItem => {
                                    if (_layerItem.id === layerItemId) 
                                        return {
                                            ..._layerItem,
                                            name
                                        };
                                    else return _layerItem;
                                }
                            )
                        })
                    ));
                }

                break;
            }
        }
    }

    function handleLayerItemModelSelectClick(layerItemId: number) {
        for (const layer of layers) {
            const layerItem = layer.layerItems?.find(_layerItem => _layerItem.id === layerItemId);

            if (layerItem) {
                if (layerItem.modelUUID) {
                    setLayerEditorActionStatus('settingModel');
                    setSelectedModelUUIDInLayerEditor(layerItem.modelUUID);
                } else {
                    setLayerEditorActionStatus('selectingModel');
                    setSelectedModelUUIDInLayerEditor(null);
                }

                break;
            }
        }
    }

    function handleLayerItemOtherModelChooseClick(layerItemId: number) {
        for (const layer of layers) {
            const layerItem = layer.layerItems?.find(_layerItem => _layerItem.id === layerItemId);

            if (layerItem) {
                setSelectedModelUUIDInLayerEditor(null);
                setLayerEditorActionStatus('selectingModel');
                setAreLayersInLayerEditorChanged(true);

                setLayers(prevLayers => prevLayers.map(prevLayer => ({
                    ...prevLayer,
                    layerItems: prevLayer.layerItems?.map(prevLayerItem => {
                        if (prevLayerItem.id === layerItemId) {
                            // az előzoleg kiválasztott modell visszaállítása
                            if (prevLayerItem.modelUUID) {
                                            
                                const model = getModelFromModelTreeInPorcessEditorByUUID(prevLayerItem.modelUUID, modelTreeInLayerEditor);
                                
                                if (model) {

                                    // modell visszaállítása az eredeti helyére (ami a modelltérben lett beállítva)
                                    if (model.isPartOfAModel) { // nem gyökérmodell

                                        if (layerEditorRef.current) {
                                            layerEditorRef.current.setModelPositionAndRotation(
                                                model.uuid,
                                                model.position,
                                                model.rotation
                                            );
                                        }

                                    } else { // gyökérmodell, vagyis state-en keresztül állítjuk
                                        setTimeout(() => {
                                            setModelsInLayerEditor(prevModels => prevModels.map(prevModel => {
                                                if (prevModel.uuid === prevLayerItem.modelUUID) {
                                                    return {
                                                        ...prevModel,
                                                        xPosition: model.position[0],
                                                        yPosition: model.position[1],
                                                        zPosition: model.position[2],
                                                        xRotation: model.rotation[0],
                                                        yRotation: model.rotation[1],
                                                        zRotation: model.rotation[2],
                                                    };
                                                }

                                                return prevModel;
                                            }));
                                        }, 0);
                                    }
                                }
                            }

                            return {
                                ...prevLayerItem,
                                modelUUID: null
                            };
                        }

                        return prevLayerItem;
                    })
                })));

                break;
            }
        }
    }

    function handleModelChangeInLayerEditor(uuid: string, data: {
        xPosition: number;
        yPosition: number;
        zPosition: number;
        xRotation: number;
        yRotation: number;
        zRotation: number;
    }) {
        if (skipModelChangeInLayerEditorRef.current) return;

        if (layerEditorActionStatus === 'settingModel') {
            if (selectedLayerItemId !== null) {
                setLayers(prevLayers => prevLayers.map(prevLayer => ({
                    ...prevLayer,
                    layerItems: prevLayer.layerItems?.map(prevLayerItem => {
                        if (prevLayerItem.id === selectedLayerItemId) {
                            if (prevLayerItem.modelUUID === uuid) {

                                if (
                                    prevLayerItem.modelXPosition !== data.xPosition ||
                                    prevLayerItem.modelYPosition !== data.yPosition ||
                                    prevLayerItem.modelZPosition !== data.zPosition ||
                                    prevLayerItem.modelXRotation !== data.xRotation ||
                                    prevLayerItem.modelYRotation !== data.yRotation ||
                                    prevLayerItem.modelZRotation !== data.zRotation
                                ) {
                                    setAreLayersInLayerEditorChanged(true);

                                    return {
                                        ...prevLayerItem,
                                        modelXPosition: data.xPosition,
                                        modelYPosition: data.yPosition,
                                        modelZPosition: data.zPosition,
                                        modelXRotation: data.xRotation,
                                        modelYRotation: data.yRotation,
                                        modelZRotation: data.zRotation
                                    };
                                } else return prevLayerItem;
                                
                            } else return prevLayerItem;
                        } else return prevLayerItem;
                    })
                })));

                // gyökérmodellek frissítése, ha változott
                if (modelsInLayerEditor.find(model => model.uuid)) {
                    setModelsInLayerEditor(prevModels => prevModels.map(
                        prevModel => {
                            if (prevModel.uuid === uuid) {
                                return {
                                    ...prevModel,
                                    xPosition: data.xPosition,
                                    yPosition: data.yPosition,
                                    zPosition: data.zPosition,
                                    xRotation: data.xRotation,
                                    yRotation: data.yRotation,
                                    zRotation: data.zRotation
                                };
                            } else return prevModel;
                        }
                    ));
                }
            }
        } else if (layerEditorActionStatus === 'settingSubmodel') {
            if (selectedLayerItemId !== null) {
                setLayers(prevLayers => prevLayers.map(prevLayer => ({
                    ...prevLayer,
                    layerItems: prevLayer.layerItems?.map(prevLayerItem => {
                        if (prevLayerItem.id === selectedLayerItemId) {
                            if (prevLayerItem.submodelUUID === uuid) {

                                if (
                                    prevLayerItem.submodelXPosition !== data.xPosition ||
                                    prevLayerItem.submodelYPosition !== data.yPosition ||
                                    prevLayerItem.submodelZPosition !== data.zPosition ||
                                    prevLayerItem.submodelXRotation !== data.xRotation ||
                                    prevLayerItem.submodelYRotation !== data.yRotation ||
                                    prevLayerItem.submodelZRotation !== data.zRotation
                                ) {
                                    setAreLayersInLayerEditorChanged(true);

                                    return {
                                        ...prevLayerItem,
                                        submodelXPosition: data.xPosition,
                                        submodelYPosition: data.yPosition,
                                        submodelZPosition: data.zPosition,
                                        submodelXRotation: data.xRotation,
                                        submodelYRotation: data.yRotation,
                                        submodelZRotation: data.zRotation
                                    };
                                } else return prevLayerItem;
                                
                            } else return prevLayerItem;
                        } else return prevLayerItem;
                    })
                })));

                // gyökérmodellek frissítése, ha változott
                if (modelsInLayerEditor.find(model => model.uuid)) {
                    setModelsInLayerEditor(prevModels => prevModels.map(
                        prevModel => {
                            if (prevModel.uuid === uuid) {
                                return {
                                    ...prevModel,
                                    xPosition: data.xPosition,
                                    yPosition: data.yPosition,
                                    zPosition: data.zPosition,
                                    xRotation: data.xRotation,
                                    yRotation: data.yRotation,
                                    zRotation: data.zRotation
                                };
                            } else return prevModel;
                        }
                    ));
                }
            }
        }
    }

    function handleLayerItemSubmodelSelectClick(layerItemId: number) {
        for (const layer of layers) {
            const layerItem = layer.layerItems?.find(_layerItem => _layerItem.id === layerItemId);

            if (layerItem) {
                if (layerItem.submodelUUID) {
                    setLayerEditorActionStatus('settingSubmodel');
                    setSelectedModelUUIDInLayerEditor(layerItem.submodelUUID);
                } else {
                    setLayerEditorActionStatus('selectingSubmodel');
                    setSelectedModelUUIDInLayerEditor(null);
                }

                break;
            }
        }
    }

    function handleLayerItemOtherSubmodelChooseClick(layerItemId: number) {
        for (const layer of layers) {
            const layerItem = layer.layerItems?.find(_layerItem => _layerItem.id === layerItemId);

            if (layerItem) {
                setSelectedModelUUIDInLayerEditor(null);
                setLayerEditorActionStatus('selectingSubmodel');
                setAreLayersInLayerEditorChanged(true);

                setLayers(prevLayers => prevLayers.map(prevLayer => ({
                    ...prevLayer,
                    layerItems: prevLayer.layerItems?.map(prevLayerItem => {
                        if (prevLayerItem.id === layerItemId) {
                            // az előzoleg kiválasztott modell visszaállítása
                            if (prevLayerItem.submodelUUID) {
                                            
                                const model = getModelFromModelTreeInPorcessEditorByUUID(prevLayerItem.submodelUUID, modelTreeInLayerEditor);
                                
                                if (model) {

                                    // modell visszaállítása az eredeti helyére (ami a modelltérben lett beállítva)
                                    if (model.isPartOfAModel) { // nem gyökérmodell

                                        if (layerEditorRef.current) {
                                            layerEditorRef.current.setModelPositionAndRotation(
                                                model.uuid,
                                                model.position,
                                                model.rotation
                                            );
                                        }

                                    } else { // gyökérmodell, vagyis state-en keresztül állítjuk
                                        setTimeout(() => {
                                            setModelsInLayerEditor(prevModels => prevModels.map(prevModel => {
                                                if (prevModel.uuid === prevLayerItem.submodelUUID) {
                                                    return {
                                                        ...prevModel,
                                                        xPosition: model.position[0],
                                                        yPosition: model.position[1],
                                                        zPosition: model.position[2],
                                                        xRotation: model.rotation[0],
                                                        yRotation: model.rotation[1],
                                                        zRotation: model.rotation[2],
                                                    };
                                                }

                                                return prevModel;
                                            }));
                                        }, 0);
                                    }
                                }
                            }

                            return {
                                ...prevLayerItem,
                                submodelUUID: null
                            };
                        }

                        return prevLayerItem;
                    })
                })));

                break;
            }
        }
    }

    function handleLayerItemSubmodelNameClick(layerItemId: number) {
        for (const layer of layers) {
            const layerItem = layer.layerItems?.find(_layerItem => _layerItem.id === layerItemId);

            if (layerItem) {
                setSelectedModelUUIDInLayerEditor(null);
                setLayerEditorActionStatus('settingSubmodelName');

                setLayers(prevLayers => prevLayers.map(prevLayer => ({
                    ...prevLayer,
                    layerItems: prevLayer.layerItems?.map(prevLayerItem => {
                        if (prevLayerItem.id === layerItemId) {
                            return {
                                ...prevLayerItem,
                                changeableSubmodelName: true
                            };
                        }

                        return prevLayerItem;
                    })
                })));

                break;
            }
        }
    }

    function handleLayerItemSubmodelNameCancelClick(layerItemId: number) {
        for (const layer of layers) {
            const layerItem = layer.layerItems?.find(_layerItem => _layerItem.id === layerItemId);

            if (layerItem) {
                setSelectedModelUUIDInLayerEditor(null);
                setLayerEditorActionStatus('clickOnSubmodelName');

                setLayers(prevLayers => prevLayers.map(prevLayer => ({
                    ...prevLayer,
                    layerItems: prevLayer.layerItems?.map(prevLayerItem => {
                        if (prevLayerItem.id === layerItemId) {
                            return {
                                ...prevLayerItem,
                                changeableSubmodelName: false
                            };
                        }

                        return prevLayerItem;
                    })
                })));

                break;
            }
        }
    }

    function handleLayerItemSubmodelNameSaveClick(layerItemId: number, name: string) {
        for (const layer of layers) {
            const layerItem = layer.layerItems?.find(_layerItem => _layerItem.id === layerItemId);

            if (layerItem) {
                setSelectedModelUUIDInLayerEditor(null);
                setLayerEditorActionStatus('clickOnSubmodelName');

                setLayers(prevLayers => prevLayers.map(prevLayer => ({
                    ...prevLayer,
                    layerItems: prevLayer.layerItems?.map(prevLayerItem => {
                        if (prevLayerItem.id === layerItemId) {
                            return {
                                ...prevLayerItem,
                                changeableSubmodelName: false,
                                submodelName: name
                            };
                        }

                        return prevLayerItem;
                    })
                })));

                break;
            }
        }
    }

    function validateLayers(_layers: typeof layers): {
        valid: true;
    } | {
        valid: false;
        errorMessage: string;
        layerId: number | null;
        layerItemId: number | null;
    } {
        for (const layer of _layers) {
            if (!layer.name) {
                return {
                    valid: false,
                    errorMessage: 'Nevezze el a réteget!',
                    layerId: layer.id,
                    layerItemId: null
                }    
            }

            if (layer.layerItems && layer.layerItems.length > 0) {
                for (const layerItem of layer.layerItems) {
                    if (!layerItem.name) {
                        return {
                            valid: false,
                            errorMessage: 'Rétegelem nevének megadása kötelező!',
                            layerId: layer.id,
                            layerItemId: layerItem.id
                        };
                    }

                    if (!layerItem.modelUUID) {
                        return {
                            valid: false,
                            errorMessage: 'Elem megadása kötelező!',
                            layerId: layer.id,
                            layerItemId: layerItem.id
                        };
                    }
                }
            }
        }

        return {
            valid: true
        };
    };

    function handleModelSelectWithDoubleClickInLayerEditorModelTree(uuid: string) {
        handleModelSelectInLayerEditor(uuid);
        if (layerEditorRef.current) layerEditorRef.current.zoomToModel(uuid);
    }

    return (
        <div className='company-admin-model-index box-shadow-4-4-8-0'>

            <div className='editor'>
                {
                    activeModelEditorType === 'modelSpace' && project.modelSpaceModule && (
                        <ModelSpace
                            ref={modelSpaceRef as LegacyRef<ModelSpaceRef>}
                            models={modelTreeInModelSpace}
                            onModelChange={handleModelChangeInModelSpace}
                            onDeleteModel={handleDeleteModelInModelSpace}
                            onAddNewModel={handleAddNewModelInModelSpace}
                            selectedModelUUID={selectedModelUUIDInModelSpace}
                            onSelectModel={(uuid) => setSelectedModelUUIDInModelSpace(uuid)}
                            isPOIActive={isPOIActive}
                            workInstructions={workInstructions}
                            onPOIChange={handlePOIChange}
                            onPOILineEndpointChange={handlePOILineEndpointChange}
                            onModelLoaded={handleModelLoadedInModelSpace}
                            areModelsLoading={areModelSpaceModelsLoading}
                            viewportShading={viewportShadingInModelSpace}
                            onViewportShadingChange={(viewportShading) => setViewportShadingInModelSpace(viewportShading)}
                        />
                    )
                }
                {
                    activeModelEditorType === 'processEditor' && project.processEditorModule && (
                        <div className='position-relative'>
                            {
                                areProcessEditorModelsLoading && (
                                    <div className="loader">
                                        <div className='spinner'>
                                            <div className='spinner-border'></div>
                                        </div>
                                    </div>
                                )
                            }

                            <ProcessEditor
                                models={modelsInProcessEditor}
                                selectedModelUUID={selectedModelUUIDInProcessEditor}
                                workInstructions={workInstructions}
                                isPOIActive={isPOIActive}
                                onSelectModel={handleModelSelectInProcessEditor}
                                onModelChange={handleModelChangeInProcessEditor}
                                instruction={instructionInProcessEditor}
                                onModelLoaded={handleModelLoadedInProcessEditor}
                                ref={processEditorRef as React.MutableRefObject<ProcessEditorRef>}
                                selectedProcessStepItem={selectedProcessStepItem}
                                enableTransformControlsOnSelectedModel={enableTransformControlsOnSelectedModelInProcessEditor}
                                viewportShading={viewportShadingInProcessEditor}
                                onViewportShadingChange={(viewportShading) => setViewportShadingInProcessEditor(viewportShading)}
                            />
                            <ModelTreeInProcessEditor
                                models={modelTreeInProcessEditor}
                                selectedUUID={selectedModelUUIDInProcessEditor}
                                onSelect={handleModelSelectInProcessEditor}
                                onSelectWithDoubleClick={handleModelSelectWithDoubleClickInProcessEditorModelTree}
                            />

                        </div>
                    )
                }
                {
                    activeModelEditorType === 'layerEditor' && project.layerEditorModule && (
                        <div className='position-relative'>

                            {
                                areLayerEditorModelsLoading && (
                                    <div className="loader">
                                        <div className='spinner'>
                                            <div className='spinner-border'></div>
                                        </div>
                                    </div>
                                )
                            }

                            <LayerEditor
                                models={modelsInLayerEditor}
                                selectedModelUUID={selectedModelUUIDInLayerEditor}
                                workInstructions={workInstructions}
                                isPOIActive={isPOIActive}
                                instruction={instructionInLayerEditor}
                                onSelectModel={handleModelSelectInLayerEditor}
                                onModelLoaded={handleModelLoadedInLayerEditor}
                                ref={layerEditorRef}
                                onModelChange={handleModelChangeInLayerEditor}
                                viewportShading={viewportShadingInLayerEditor}
                                onViewportShadingChange={(viewportShading) => setViewportShadingInLayerEditor(viewportShading)}
                            />

                            <ModelTreeInLayerEditor
                                models={modelTreeInLayerEditor}
                                selectedUUID={selectedModelUUIDInLayerEditor}
                                onSelect={handleModelSelectInLayerEditor}
                                onSelectWithDoubleClick={handleModelSelectWithDoubleClickInLayerEditorModelTree}
                            />

                        </div>
                    )
                }
            </div>

            <div className='editor-data'>
                <EditorDataViewer
                    project={project}
                    activeTab={activeModelEditorType}
                    onTabChange={(tab) => setActiveModelEditorType(tab)}

                    // model space property-k
                    modelTreeInModelSpace={modelTreeInModelSpace}
                    selectedModelUUIDInModelSpace={selectedModelUUIDInModelSpace}
                    onSelectModelInModelSpace={(uuid) => setSelectedModelUUIDInModelSpace(uuid)}
                    onChangeModelNameInModelSpace={handleModelNameChangeInModelSpace}
                    onVisibleChangeInModelSpace={handleVisibleChangeInModelSpace}
                    areModelSpaceModelsLoading={areModelSpaceModelsLoading}
                    onSelectModelWithDoubleClickInModelSpace={handleSelectModelWithDoubleClickInModelSpace}
                    
                    // process editor property-k
                    processSteps={processSteps}
                    selectedModelUUIDInProcessEditor={selectedModelUUIDInProcessEditor}
                    selectedProcessStepId={selectedProcessStepId}
                    onProcessStepSelect={(id) => setSelectedProcessStepId(id)}
                    selectedProcessStepItemId={selectedProcessStepItemIdInProcessEditor}
                    onProcessStepItemSelect={(processStepItemId) => setSelectedProcessStepItemIdInProcessEditor(processStepItemId)}
                    onProcessStepItemModelSelect={(uuid) => setSelectedModelUUIDInProcessEditor(uuid)}
                    onAddNewProcessStep={handleAddNewProcessStep}
                    onAddNewProcessStepItem={handleAddNewProcessStepItem}
                    onToolChoseForProcessStepItem={handleToolChooseForProcessStepItem}
                    onProcessStepNameChange={handleProcessStepNameChange}
                    onProcessStepDelete={(processStepId) => handleProcessStepDelete(processStepId)}
                    onProcessStepItemDelete={(processStepItemId) => handleProcessStepItemDelete(processStepItemId)}
                    procesStepsViewerDisabled={areProcessEditorModelsLoading}
                    onProcessStepItemStartingModelClick={handleProcessStepItemStartingModelClick}
                    onSettingProcessStepItemStartingModelVisible={handleSettingProcessStepItemStartingModelVisible}
                    onSettingProcessStepItemModelToBeMovedConnectedToReferenceModel={handleSettingProcessStepItemModelToBeMovedConnectedToReferenceModel}
                    onProcessStepIteReferenceModelClick={handleProcessStepItemReferenceModelClick}
                    onToolDeleteForProcessStepItem={handleToolDeleteForProcessStepItem}
                    onProcessStepItemEndpointClick={handleProcessStepItemEndpointModelClick}
                    onProcessStepItemEndpointDeleteClick={handleProcessStepItemEndpointDeleteClick}
                    onProcssStepItemDoneClick={handleProcessStepItemDoneClick}

                    // layer editor proeprty-k
                    layers={layers}
                    layersViewerDisabled={areLayerEditorModelsLoading}
                    selectedLayerId={selectedLayerId}
                    selectedLayerItemId={selectedLayerItemId}
                    selectedModelUUIDInLayerEditor={selectedModelUUIDInLayerEditor}
                    onLayerSelect={(id) => setSelectedLayerId(id)}
                    onLayerItemSelect={(id) => setSelectedLayerItemId(id)}
                    onNewLayerAdd={handleNewLayerAdd}
                    onNewLayerItemAdd={handleNewLayerItemAdd}
                    onLayerItemModelSelect={(uuid) => setSelectedModelUUIDInLayerEditor(uuid)}
                    onLayerNameChange={handleLayerNameChange}
                    onLayerDelete={handleLayerDelete}
                    onLayerItemDelete={handleLayerItemDelete}
                    onLayerItemNameChange={handleLayerItemNameChange}
                    onLayerItemModelSelectClick={handleLayerItemModelSelectClick}
                    onLayerItemOtherModelChooseClick={handleLayerItemOtherModelChooseClick}
                    onLayerItemSubmodelSelectClick={handleLayerItemSubmodelSelectClick}
                    onLayerItemOtherSubmodelChooseClick={handleLayerItemOtherSubmodelChooseClick}
                    onLayerItemSubmodelNameClick={handleLayerItemSubmodelNameClick}
                    onLayerItemSubmodelNameCancelClick={handleLayerItemSubmodelNameCancelClick}
                    onLayerItemSubmodelNameSaveClick={handleLayerItemSubmodelNameSaveClick}

                    onSave={handleSave}
                    needSave={needSave}

                    isPOIActive={isPOIActive}
                    onIsPOIActiveChange={(isActive) => setIsPOIActive(isActive)}
                />
            </div>

        </div>
    );
};